import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Slide,
  IconButton,
  ClickAwayListener,
  InputBase,
  Button,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Tabs,
  Tab,
  Box,
  Modal,
  Divider,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  TextField,
  FormControlLabel,
  RadioGroup,
  Radio,
  Checkbox,
  ListItemText,
  OutlinedInput,
  Pagination,
  CircularProgress,
  Link,
  Avatar,
  
} from '@mui/material';

import { pink } from '@mui/material/colors';

import { styled } from '@mui/material/styles';
import { Icon } from '@iconify/react';
import moment from 'moment';
import { CopyToClipboard } from 'react-copy-to-clipboard';
// import { ToastContainer, toast } from 'react-toastify';
import dayjs from 'dayjs'; 
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CustomCompleteResumeDatabaseCity from '../components/customComplete/CustomCompleteResumeDatabaseCity';
import CustomCompletesResumeDatabaseState from '../components/customComplete/CustomCompletesResumeDatabaseState';
import Iconify from '../components/iconify';
import MyCustomUploadAdapterPlugin from './customEditor/customEditor';
// import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import Scrollbar from '../components/scrollbar/Scrollbar';
import countries from './countryJson/countryJson.json';
import { Api, UploadFile } from '../webservices';

const filter = createFilterOptions();

function ResumeDatabase() {

  const visalist = [
    { label: 'USC' },
    { label: 'GC' },
    { label: 'GCEAD' },
    { label: 'TN' },
    { label: 'H1B' },
    { label: 'H1b I 140 ' },
    { label: 'H4 EAD' },
    { label: 'OPT EAD' },
    { label: 'CPT EAD' },
    { label: 'E2 Visa' },
    { label: 'B 1 Visa' },
    { label: 'Canadian citizen' },
    { label: 'Open work permit' },
    { label: 'Permanent Resident' },
  ];

  const styleClients1 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '40%', sm: '60%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const styless = {
    position: 'absolute',
    top: '48%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { md: '50%', xs: '95%' },
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 3,
    border: '3px solid #3C6BA5',
    borderRadius: 3,
  };
 
  const navigate = useNavigate()
  const [value, setValue] = useState('foxearchDB');
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
  const [checked, setChecked] = useState(false);
  // const [checkedSearch, setCheckedSearch] = useState(false);
  const [searchData, setSearchData] = useState([])
  const [savedSearchData, setSavedSearchData] = useState([])
  const [recBenchData, setRecBenchData] = useState([])
  const [moveToId, setMoveToId] = useState([])
  const [selectedIds, setSelectedIds] = useState([]);
  const [checkedStates, setCheckedStates] = useState({});
  const [skillLst, setSkillLst] = useState([]);
  // const [finallst, setFinallst] = useState([]);
  const [total, setTotal] = useState('')
  const [totalHide, setTotalHide] = useState(false)
  const [foxSearch, setFoxSearch] = useState([])
  const [loading, setLoading] = useState()
  const [loading1, setLoading1] = useState()
  const [dist, setDistance] = useState()
  const [latt, setLatt] = useState(null)
  const [long, setLong] = useState(null)
  const [cityData, setCityData] = useState([]);
  const [cityAndState, setCityAndState] = useState(null);
  const [stateCode, setStateCode] = useState('')
  const [stateData, setStateData] = useState([]);
  const [cityQuery, setCityQuery] = useState("");
  const [stateQuery, setStateQuery] = useState("");
  const [stateId, setStateId] = useState("");
  const [selectedState, setSelectedState] = useState(null);
  const [advaSearch, setAdvaSearch] = useState(false)
  const [search, setSearch] = useState(true)
  const [phoneCopy, setPhoneCopy] = useState(false);
  const [emailCopy, setEmailCopy] = useState(false);
  const [vendorSearch, setVendorSearch] = useState(true)
  const tablebg = 'rgba(82, 130, 190, 0.08)';
  const [resumeUrl, setResumeUrl] = useState('')
  const [autoSearch, setAutoSearch] = useState(false)
  const [countryReq, setCountryReq] = useState(false)

  const [ResumeDatabaseId, setResumeDataBaseId] = useState()
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  const confirmCloseDelete = () => setOpenConfirmDelete(false);
  const confirmOpenDelete = (id) => {
    setResumeDataBaseId(id)
    setOpenConfirmDelete(true);
  }

  const [reason, setReason] = useState()
  // console.log("cityQuery", cityQuery)
  // console.log("stateQuery", stateQuery)
  // https://foxstoragefoxearch.s3.ap-south-1.amazonaws.com/resume/rrVVKFXqZXVeElPGvZStuHpTp.docx

  const handleChecked = () => {
    setChecked(prevChecked => !prevChecked);
  };

  const handleCheckedSearch1 = (index, id) => {
    // console.log("id", id);
    setCheckedStates((prevState) => {
      const newState = { ...prevState, [index]: !prevState[index] };
      if (newState[index]) {
        setSelectedIds((prevIds) => [...prevIds, id]);
      } else {
        setSelectedIds((prevIds) => prevIds?.filter((item) => item !== id));
      }
      return newState;
    });
  };

  // const handleCheckedSearch = (itemId) => {
  //   // console.log("itemId", itemId);
  //   setCheckedStates((prev) => ({
  //     ...prev,
  //     [itemId]: !prev[itemId],
  //   }));
  // };

//   const handleCheckedSearch = (itemId, email, name) => {
//   const isChecked = !checkedStates[itemId];
//   const formattedName = (name || "")
//     .split(" ")
//     .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
//     .join(" ");
//   if (isChecked) {
//     setBccEmail((prev) => {
//       const alreadyExists = prev.some((item) => item.email === email);
//       if (!alreadyExists) {
//         return [...prev, { name: formattedName, email }];
//       }
//       return prev;
//     });
//   } else {
//     setBccEmail((prev) => prev.filter((item) => item.email !== email));
//   }
//   setCheckedStates((prev) => ({
//     ...prev,
//     [itemId]: isChecked,
//   }));
// };

const handleCheckedSearch = (itemId, email, name) => {
  const isChecked = !checkedStates[itemId];

  const formattedName = (name || "")
    .split(" ") 
    .map( 
      (word) =>
        word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase()
    )
    .join(" ");

  setBccEmail((prev) => {
    let updated;

    if (isChecked) {
      const alreadyExists = prev?.some((item) => item.email === email);
      if (!alreadyExists) {
        updated = [...prev, { name: formattedName, email }];
      } else {
        updated = prev;
      }
    } else {
      updated = prev.filter((item) => item.email !== email);
    }

    if (updated?.length > 0) {
      setRecipientEmail(updated[0]?.email);
    } else {
      setRecipientEmail("");
    }

    return updated;
  });

  setCheckedStates((prev) => ({
    ...prev,
    [itemId]: isChecked,
  }));
};

  const moveTo = () => {
    // console.log("moveToCalled");
    foxSearch?.forEach((item) => {
      // console.log("moveToCalled1");
      if (checkedStates[item._id]) {
        if (value !== "foxearchDB") {
          // moveToBench(item?.benchAppId);
          moveToWorksheet(item?.benchAppId);
        } else {
          moveToWorksheet(item?.recruitorAppId);
        }
      }
    });
    setCheckedStates({});
  };


  // console.log("selectedIds", selectedIds)

  const addToWs = async () => {
    const body = {
      "worksheet_idArray": selectedIds,
      dataFrom: "foxearchdb"
    }
    const token = localStorage.getItem('token');
    Api('database/addDataToRecruitorWorksheet', 'POST', body, token).then((Response) => {
      // console.log("Response.data")
      if (Response.status === 200) {
        toast.success(Response.data?.resmessage)
      } else {
        toast.warn(Response.data?.resmessage)
      }
    })
  }

  const addToBench = async () => {
    const body = {
      "worksheet_idArray": selectedIds,
      dataFrom: "foxearchdb"
    }
    const token = localStorage.getItem('token');
    Api('database/addDataToBenchWorksheet', 'POST', body, token).then((Response) => {
      // console.log("Response.data")
      if (Response.status === 200) {
        toast.success(Response.data?.resmessage)
      } else {
        toast.warn(Response.data?.resmessage)
      }
    })
  }

  const moveToWorksheet = (row) => {
    if (!row.email) {
      toast.error("Email is required");
      return;
    }
    if (!row.fullName) {
      toast.error("Full name is required");
      return;
    }
    if (!row.jobTitle) {
      toast.error("Job title is required");
      return;
    }
    const body = {
      "newCV": "no",
      email: row.email,
      fullName: row.fullName,
      jobTitle: row.jobTitle,
      phone: row.phone,
      currentCompany: row.currCompany,
      skill: row.skill,
      // visaType: row.visa,
      taxTerm: row.taxTerm,
      chargeType: row.chargeType,
      expectedCompensation: row.expectedCompensation,
      linkedinUrl: row.linkedinUrl,
      reallocate: row.reallocate,
      resumeUrl: row.resumeUrl || row?.resumeFile?.resumeFileUrl,
      jobId: row.jobid,
      note: row.notes,
      zipcode: row.zip,
      country: row.country,
      status: row.status,
      userStatus: row.userStatus,
      dataFrom: "foxearchdb",
      city: row.city,
      state: row.state,
      "additionalResumes": row.additionalResumes,
      "stateCode": row.stateCode,
      "visaType": row.visaType,
    };

    const token = localStorage.getItem("token")
    Api(`resume/create_resume`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200 && response.data.code === 200) {
          toast.success('Data successfully moved!');
          // setLoadingMov(false)
          // selectTab(moveToData)
          //   setValuee(moveToData)
        } else {
          toast.warn("A resume with the same email already exists");
          // setLoadingMov(false)

        }
      })
      .catch(error => {
        console.error('API error:', error);
        // toast.error("An error occurred while moving data.");
      });
  };

  const moveToBench = (row) => {
    if (!row.email) {
      toast.error("Email is required");
      return;
    }
    if (!row.fullName) {
      toast.error("Full name is required");
      return;
    }
    if (!row.jobTitle) {
      toast.error("Job title is required");
      return;
    }
    const body = {
      dataFrom: "foxearchdb",
      email: row.email,
      fullName: row.fullName,
      jobTitle: row.jobTitle,
      phone: row.phone,
      currentCompany: row.currCompany,
      skill: row.skill,
      visaType: row.visa,
      visaTransfer: row.visaTrn,
      taxTerm: row.tax,
      chargeType: row.comType,
      expectedCompensation: row.expectedCom,
      cityOrZipcode: row.city,
      linkedinUrl: row.linkedinUrl,
      reallocate: row.reloc,
      zipcode: row.zip,
      stateCode: row.stateCode,
      resumeUrl: row.pdffile,
      state: row.state,
      visaFile: row.pdffileVisa,
      otherFile: row.pdffileOtherDoc,
      i94_File: row.pdffile94,
      DL_File: row.pdffileDL,
      note: row.notes,
      userStatus: row.userStatus,
      country: row.country,
      validity: row.validity,
      DOB: row.dateofbirth,
      summary: row.summary,
      experienceInYear: row.yearExp
    };

    const token = localStorage.getItem("token")
    Api(`bench/addNewBenchProspect`, 'POST', body, token)
      .then((response) => {
        // console.log('=====bench==========>>>>>>>', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            // setLoadingMov(false);
            toast.success('Data successfully moved!');
            // getConsultData();
            // setValuee("consult");

          } else {
            toast.warn("A bench worksheet with the same email already exists");
          }
        } else {
          toast.warn("A bench worksheet with the same email already exists");
        }
      })
      .catch((err) => {
        // console.log('===========', err);

      })
      .finally(() => {
        // setLoadingMov(false);
      });
  };

  const addToBench1 = (row) => {
    if (!row.email) {
      toast.error("Email is required");
      return;
    }
    if (!row.fullName) {
      toast.error("Full name is required");
      return;
    }
    if (!row.jobTitle) {
      toast.error("Job title is required");
      return;
    }
    const body = {
      dataFrom: "foxearchdb",
      email: row.email,
      fullName: row.fullName,
      jobTitle: row.jobTitle,
      phone: row.phone,
      currentCompany: row.currCompany,
      skill: row.skill,
      visaType: row.visa,
      visaTransfer: row.visaTrn,
      taxTerm: row.tax,
      chargeType: row.comType,
      expectedCompensation: row.expectedCom,
      cityOrZipcode: row.city,
      linkedinUrl: row.linkedinUrl,
      reallocate: row.reloc,
      zipcode: row.zip,
      stateCode: row.stateCode,
      resumeUrl: row.pdffile,
      state: row.state,
      visaFile: row.pdffileVisa,
      otherFile: row.pdffileOtherDoc,
      i94_File: row.pdffile94,
      DL_File: row.pdffileDL,
      note: row.notes,
      userStatus: row.userStatus,
      country: row.country,
      validity: row.validity,
      DOB: row.dateofbirth,
      summary: row.summary,
      experienceInYear: row.yearExp
    };

    const token = localStorage.getItem("token")
    Api(`bench/addNewBenchProspect`, 'POST', body, token)
      .then((response) => {
        // console.log('=====bench==========>>>>>>>', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            // setLoadingMov(false);
            toast.success('Data successfully moved!');
            // getConsultData();
            // setValuee("consult");

          } else {
            toast.warn("A bench worksheet with the same email already exists");
          }
        } else {
          toast.warn("A bench worksheet with the same email already exists");
        }
      })
      .catch((err) => {
        // console.log('===========', err);

      })
      .finally(() => {
        // setLoadingMov(false);
      });
  };

  const handleTab = (tab) => {
    setChecked(false)
    setPageNumber(1)
    // setMoveToId([])
    setSelectedIds([])
    setAdvaSearch(false)
    clearAll()
    setValue(tab);
    setCheckedStates({})
  };

  // console.log("checked", checked)
 
  useEffect(() => {
    getTemplList()
    searchHisLst()
    savedSearchList()
    recBenchDatabaseLst()
    getSkills()
  }, [])

  const searchHisLst = async () => {
    setSearchData([])
    const token = localStorage.getItem('token');
    Api('database/searchHistoryList/recruitor', 'GET', '', token).then((Response) => {
      if (Response.status === 200 && Response.data.status === 200) {
        setSearchData(Response.data?.databaseList)
      } else {
        setLoading('No data found')
        setSearchData([])
      }
    }) 
  }

  const savedSearchList = async () => {
    setSavedSearchData([])
    const token = localStorage.getItem('token');
    Api('database/SavedSearchHistoryList/recruitor', 'GET', '', token).then((Response) => {
      if (Response.status === 200 && Response.data.status === 200) {
        setSavedSearchData(Response.data?.pastSavedSearchHistory)
      } else {
        setLoading('No data found')
        setSavedSearchData([])
      }
    })
  }

  // const recBenchDatabaseLst = async () => {
  //   setLoading('Loading...');
  //   const token = localStorage.getItem('token');
  //   Api('database/recruitorDatabaseList/bench', 'GET', '', token).then((Response) => {
  //     if (Response.status === 200 && Response.data?.status === 200) {
  //       const searchResult = Response.data?.searchResult;
  //       if (Array.isArray(searchResult) && searchResult?.length > 0) {
  //         setRecBenchData(searchResult);
  //         setLoading('');
  //       } else {
  //         setLoading('No data found');
  //       }
  //     } else if (Response.status === 201) {
  //       setLoading('Subscribe to the Foxearch Database to access these services. To activate this option, please contact our support team at support@foxearch.com');
  //     } else {
  //       setLoading('No data found');
  //     }
  //   })
  // }

  const recBenchDatabaseLst = async () => {
  setLoading1('Loading...');
  const token = localStorage.getItem('token');
  Api('database/recruitorDatabaseList/bench', 'GET', '', token).then((Response) => {
    console.log("Full Response:", Response);

    if (Response.status === 200 && Number(Response.data?.status) === 200) {
      const searchResult = Response.data?.searchResult;
      console.log("searchResult:", searchResult);

      if (Array.isArray(searchResult) && searchResult.length > 0) {
        setRecBenchData(searchResult);
        setLoading1('');
      } else {
        setLoading1('No data found');
      }
    } else if (Response.status === 201) {
      setLoading1('Subscribe to the Foxearch Database to access these services. To activate this option, please contact our support team at support@foxearch.com');
    } else {
      setLoading1('No data found');
    }
  });
};

  // console.log("searchData===>>>>", searchData)
  // console.log("recBenchData===>>>>", recBenchData)
  // console.log("savedSearchData===>>>>", savedSearchData)
  // console.log("recBenchData===>>>>", recBenchData)

  const getSkills = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await Api(`resume/get_skills/${"other"}`, 'GET', '', token);

      if (response.data.code === 200) {
        const skillsData = response.data.result;
        const updatedSkills = skillsData.map((item) => ({ title: item.skillName }));
        setSkillLst(updatedSkills);
        // console.log('Updated Skills:', updatedSkills);
      } else {
        setSkillLst([{ title: '' }]);
        toast.warn(response.data.message);
      }
    } catch (error) {
      // console.error('Error fetching skills:', error);
      toast.error('Failed to fetch skills!');
    }
  };

  const [values, setValues] = useState({
    jobTitle: [],
    // jobTitle: '',
    skills: '',
    country: localStorage.getItem("country"),
    city: "",
    state: "",
    distance: "",
    relocation: "",
    visa: ""
  });

  const [lastSearch, setLastSearch] = useState('')
  const foxDBSearch = async (e, page) => {

    // console.log("item", item)
    //   setCityQuery(item?.city);
    // setStateQuery(item?.state);
    setValues({
      ...values,
      // jobTitle:(Array?.isArray(item?.jobTitle) ? item?.jobTitle : [item?.jobTitle]),
      // skills: item?.skill,
      // country: "USA",

      // distance: item?.distance,
      // relocation: item?.relocation || '',
      // visa:""
    });

    setPages('')
    setTableCount('')
    // console.log("item?.skills", item?.skill)
    setTotalHide(true)
    setTotal('')
    setResumeUrl('')
    setFoxSearch([])
    setLoading("Loading...")
    setSearch(false)
    setVendorSearch(false)
    // console.log("values?.jobTitle", values?.jobTitle)
    const body = {
      "isSaved": checked ? "yes" : "no",
      "from": value === "foxearchDB" ? "recruitor" : "bench",
      // "coutry": values?.country || item?.country,
      "jobTitle": values?.jobTitle,
      // "country": countryReq ? values.country : "",
      "country": values.country,
      "skill": values?.skills,
      // "stateCode": stateCode || stateId,
      "city": cityQuery,
      "state": stateQuery,
      // "distance": "",
      "relocation": values?.relocation,
      "page": page || 1,
      "limit": "6",
      "visa": values?.visa,
      "center": [long, latt],
      "radiusInMiles": values?.distance,
    }
    setLastSearch(body)
    const token = localStorage.getItem('token');
    Api('database/searchDatabaseApi', 'POST', body, token).then((Response) => {
      // console.log("Response.data")
      setTableCount(Response.data?.count)
      setTotal(Response.data?.count)
      if (Response.status === 200 && Response.data.status === 200) {
        const totalPage = Math?.ceil(Response.data?.count / 6)
        setPages(totalPage)
        // setTotalHide(true)
        setLoading('')
        setResumeUrl(Response.data?.searchResult)
        setFoxSearch(Response.data?.searchResult)
        // searchHisLst()
        // savedSearchList()
        // recBenchDatabaseLst()

      } else if (Response.status === 201) {
        setLoading('Subscribe to the Foxearch Database to access these services. To activate this option, please contact our support team at support@foxearch.com')
      }
      else {
        setLoading('No data found')
      }
    })
  }

  const foxDBSearchAuto = async (item, page) => {
    console.log("item ===>>>>>>>>>", item)
    setCityQuery(item?.city);
    setStateQuery(item?.state);
    setValues({
      ...values,
      "jobTitle": Array.isArray(item?.jobTitle) 
                ? item?.jobTitle?.filter(title => title !== null && title !== undefined) 
                : item?.jobTitle ? [item?.jobTitle] : [],
      
      skills: item?.skill,
      country: item.country,
      distance: item?.distance,
      relocation: item?.relocation || '',
      visa: item?.visaType
    });

    setPages('')
    setTableCount('')
    // console.log("item?.skills", item?.skill)
    setTotalHide(true)
    setTotal('')
    setResumeUrl('')
    setFoxSearch([])
    setLoading("Loading...")
    setSearch(false)
    setVendorSearch(false)
    // console.log("values?.jobTitle", values?.jobTitle)
    const body = {
      "isSaved": checked ? "yes" : "no",
      "from": value === "foxearchDB" ? "recruitor" : "bench",
      // "coutry": values?.country || item?.country,
     "jobTitle": Array.isArray(item?.jobTitle) 
                ? item?.jobTitle?.filter(title => title !== null && title !== undefined) 
                : item?.jobTitle ? [item?.jobTitle] : [],
      
      "country": item?.country,
      "skill": item?.skill,
      // "stateCode": stateCode || stateId,
      "city": item.city,
      "state": item.state,
      // "distance": "",
      "relocation": item?.relocation,
      "page": page || 1,
      "limit": "6",
      "visa": item?.visaType,
      "center": [long, latt],
      "radiusInMiles": item?.distance,
    }
    setLastSearch(body)
    const token = localStorage.getItem('token');
    Api('database/searchDatabaseApi', 'POST', body, token).then((Response) => {
      // console.log("Response.data")
      setTableCount(Response.data?.count)
      setTotal(Response.data?.count)
      if (Response.status === 200 && Response.data.status === 200) {
        const totalPage = Math?.ceil(Response.data?.count / 6)
        setPages(totalPage)
        // setTotalHide(true)
        setLoading('')
        setResumeUrl(Response.data?.searchResult)
        setFoxSearch(Response.data?.searchResult)
        // searchHisLst()
        // savedSearchList()
        // recBenchDatabaseLst()

      } else if (Response.status === 201) {
        setLoading('Subscribe to the Foxearch Database to access these services. To activate this option, please contact our support team at support@foxearch.com')
      }
      else {
        setLoading('No data found')
      }
    })
  }

  const searchDis = async (page) => {

    //   setCityQuery(item?.city);
    // setStateQuery(item?.state);
    //   setValues({ ...values,
    //     // jobTitle: item?.jobTitle,
    //     skills: item?.skills,
    //     // country: "USA",
    //     distance: item?.distance,
    //     relocation: item?.relocation || '',
    //     visa:""
    //   });

    setPages('')
    setTableCount('')
    setTotalHide(true)
    setTotal('')
    setResumeUrl('')
    setFoxSearch([]);
    setLoading("Loading...");
    setSearch(false);
    setVendorSearch(false);

    const body = {
      "jobTitle": values?.jobTitle,
      "skill": values?.skills,
      // "stateCode": stateCode || stateId,
      "city": cityQuery,
      "state": stateQuery,
      "distance": "",
      "relocation": values?.relocation,
      "isSaved": checked ? "yes" : "no",
      "from": value === "foxearchDB" ? "recruitor" : "bench",
      "center": [long, latt],
      "radiusInMiles": values?.distance,
      "page": page || 1,
      "limit": "6",
      "visa": values?.visa
    };

    const token = localStorage.getItem('token');
    Api('database/searchDatabaseApi', 'POST', body, token).then((Response) => {
      // console.log("Response.data")
      if (Response.status === 200 && Response.data?.searchResult?.length > 0) {
        setTableCount(Response.data?.count)
        const totalPage = Math?.ceil(Response.data?.count / 6)
        setPages(totalPage)
        // setTotalHide(true)
        setTotal(Response.data?.count)
        setLoading('')
        setResumeUrl(Response.data?.searchResult)
        setFoxSearch(Response.data?.searchResult)
        // searchHisLst()
        // savedSearchList()
        // recBenchDatabaseLst()
      } else {
        setLoading('No data found')
      }
    })
  }

  const handleSearch = (e, value) => {
    setAutoSearch(false)
    console.log("value1", value)
    foxDBSearch('', value)
    setAdvaSearch(true)
    // setCountryReq(false)
    // if(autoSearch) {
    //   foxDBSearchAuto(item, value)

    // } else {
    //   foxDBSearch('', value)

    // }
    // if (values?.distance) {
    //   // console.log("disc")
    //   searchDis(value);
    //   setDistance('')
    //   setStateCode('')
    // } else {
    //   foxDBSearch(item, value)
    //   // console.log("common")
    //   setStateCode('')
    //   setDistance('')
    // }
  };

  const [err, setErr] = useState(false); 
  const [helperText, setHelperText] = useState(''); 

  const getCity = async (val) => {
    setHelperText('')
    setErr(false)
    const token = localStorage.getItem('token');
    const body = {
      country: values.country,
      query: val,
    };
    try {
      const response = await Api('resume/get_city_states', 'POST', body, token);
      if (response.status === 200 && response.data.code === 200) {
        setCityData(response.data.data || []);

      } else {
        console.error(response.data.message);
        // toast.error(response.data.message)
        setHelperText("No cities found for the given city name.")
        setErr(true)
        setCityData([]);
      }
    } catch (err) {
      console.error(err);
      setCityData([]);
    }

  };

  const childFuc = (val) => {
    setCityData([])
    // console.log("vall===", val)
    if (typeof (val) === "string") {
      // console.log("val", val)
      // alert("USA")
      if (val.length >= 3) {
        getCity(val);
      }

      setCityQuery(val);
      // handleCityChange(val);
    }
    else {
      // alert("CAN") 
      if (val.city.length >= 3) {
        getCity(val.city);
      }
      setStateQuery(val?.state)
      setCityQuery(val?.city);
      // handleCityChange(val.city);
      setLatt(val?.lat);
      setLong(val?.lng);
      setStateCode(val?.stateCode || val?.postal)
    }

  };

  const handleStateChange = async (val) => {
    // console.log("=======", val)
    // alert("hh")
    setStateQuery(val?.state_name || val?.province_or_StateName);
    setStateId(val?.state_id || val?.province_id)
    // await getState(val);
    // console.log("val====",val)
    if (val.length >= 3) {
      await getState(val);
    }
  };

  const getState = async (val) => {
    const token = localStorage.getItem('token');
    const body = {
      country: values.country,
      stateName: val,
    };
    try {
      const response = await Api('resume/get_states', 'POST', body, token);
      if (response.status === 200 && response.data.code === 200) {
        setStateData(response.data.data || []);

      } else {
        console.error(response.data.message);
        setStateData([]);
      }
    } catch (err) {
      console.error(err);
      setStateData([]);
    }
  };

  const childFucState = async (val) => {
    // console.log("stateval", val)
    setStateQuery(val?.state_name || val?.province_or_StateName);
    handleStateChange(val);

  };

  const clearAll = () => {
    //  if(value === "vendor"){
    //   recBenchDatabaseLst()
    // }
    //  if (value === "foxearchDB") {
    //   searchHisLst()
    //   savedSearchList() 
    // }
    searchHisLst()
    savedSearchList()
    setChecked(false)
    setPageNumber(1)
    setCityQuery('')
    setStateQuery('')
    setCheckedStates({})
    // setMoveToId([])
    setSelectedIds([])
    setTotalHide(false)
    setTotal('')
    setSearch(true)
    setVendorSearch(true)
    
    setValues({
      ...values,
      // jobTitle: '',
      jobTitle: [],
      skills: '',
      country: localStorage.getItem("country"),
      city: "",
      state: "",
      distance: "",
      relocation: "",
      visa: ""
    })

   setSubject('');
    setEmailBody('');
    setCcEmail([]);
  setBccEmail([]);
    setFileName('')
    setFileType('')
  setAttachment('')
  }

  // console.log("jobTitle", values?.jobTitle)
  // console.log("foxSearch", foxSearch)

  // console.log("checkedStates", Object.keys(checkedStates).length)

  // const handleClick = (item) =>{
  //   foxDBSearch(item)
  // // console.log("item", item)

  // }

  const optionsDate = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    // timeZone: 'UTC'
  };

  const [selectedDropdownValue, setSelectedDropdownValue] = useState('foxearchDB');
  const handleChangeDrop = (event) => {
    console.log("event", event)
    const selectedTab = event.target.value;
    setSelectedDropdownValue(selectedTab)
  }

  const Funcc = () => {
    const selectedTab = selectedDropdownValue;
    if (selectedTab === 'foxearchDB') {
      handleTab(selectedTab);
    } else if (selectedTab === 'vendor') {
      handleTab(selectedTab);
    }
  }

  const suru = 'https://docs.google.com/viewer?url=';
  const lll = '&embedded=true';

  const [visibleItems, setVisibleItems] = useState(8);
  const [showAll, setShowAll] = useState(false);

  const handleToggle = () => {
    setShowAll((prevState) => !prevState);
    setVisibleItems(showAll ? 8 : searchData?.length);
  };

  console.log("searchData?.length", searchData?.length)

  const [showAll1, setShowAll1] = useState(false);

  const handleToggle1 = () => {
    setShowAll1(prevState => !prevState);
  };

  const displayedItems = showAll1 ? savedSearchData : savedSearchData?.slice(0, 8);

  const [showAll2, setShowAll2] = useState(false);

  const handleToggle2 = () => {
    setShowAll2(prevState => !prevState);
  };

  const displayedItems1 = showAll2 ? recBenchData : recBenchData?.slice(0, 8);

  const [tableCount, setTableCount] = useState('')

  const [pages, setPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(1)

  const handlePage = (event, value) => {
    setCheckedStates({})
    setPageNumber(value);

    // handleSearch("", value)
    if (autoSearch) {
      console.log("lastSearch", lastSearch)
      foxDBSearchAuto(lastSearch, value)
      // alert("foxDbAuto")

    } else {
      foxDBSearch('', value)
// alert("foxDb")
      // console.log("value", value)
    };
  }

  console.log("tableCount", tableCount)

  const [opens, setOpens] = useState(false);
  const [skillsArrayLst, setSkillsArrayLst] = useState()
  const handleOpens = (skillArr) => {
    console.log('skillArr', skillArr)
    setSkillsArrayLst(skillArr)
    setOpens(true);
  }

  const handleCloses = () => setOpens(false);

  const styleSkillset11 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '60%', sm: '80%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    // paddingTop:3,
    // paddingBottom:3,
    borderRadius: 3,
  };

  const [resumeUrl1, setResumeUrl1] = useState('')

  console.log("resumeUrl1", resumeUrl1)

  const [summary, setSummary] = useState('')
  const [summaryModal, setSummaryModal] = useState(false)

  const openSummary = (summary) => {
    setSummary(summary)
    console.log("summary===========>>", summary)
    setSummaryModal(true)
  }

  const closeSummary = () => setSummaryModal(false)

  const searchEnabled =
    (values?.jobTitle?.length > 0) ||

    (values?.skills || "") ||
    (cityQuery || "") ||
    (stateQuery || "") ||
    (values?.relocation || "") ||
    (values?.distance || "") ||
    (values?.visa || "")

  const spamData = () => {
    const body = {
      "database_id": ResumeDatabaseId,
      "reason": reason
    }
    const token = localStorage.getItem('token');
    Api('database/reportTheData', 'POST', body, token).then((Response) => {
      // console.log("Response.data")
      if (Response.status === 200) {
        if (Response.data.status === 200) {
          foxDBSearchAuto(lastSearch, pageNumber)
          toast.success(Response.data?.resmessage)
          confirmCloseDelete()
          setReason('')
        }
      } else {
        toast.warn(Response.data?.resmessage)
      }
    })
  }

  const [recipientEmail, setRecipientEmail] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const handleOpenModal = (email) => {
    // setRecipientEmail(email)
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const [greeting, setGreeting] = useState('')
   
    const [subject, setSubject] = useState('');
    const [emailBody, setEmailBody] = useState('');
    const [ccEmail, setCcEmail] = useState([]);
  const [bccEmail, setBccEmail] = useState([]);
    const [base64, setBase64] = useState([])
    const [fileName, setFileName] = useState('')
    const [fileType, setFileType] = useState('')
  const [attachment, setAttachment] = useState('')
  
    const FileChange = (event) => {
      const file = event.target.files[0];
      // console.log("file---", event.target.files)
      if (file) {
        setFileName(file.name)
        setFileType(file.type)
        convertFileToBase64(file);
         uploadAttach(file)
      } else {
        toast.warn('No file selected!');
      }
    };
  
    const uploadAttach = async (file) => {
              const token = localStorage.getItem('token');
              const formData = new FormData();
              formData.append('document', file);
              formData.append('directoryName', 'profile');
              try {
                  const response = await UploadFile('resume/upload_resume', formData, token);
                  if (response.status === 200 && response.data.code === 200) {
                      setAttachment(response.data.filePath)
                  } else {
                      //   toast.warn(response.data.status + '!');
                  }
              } catch (error) {
                  // toast.warn('Error uploading the image!');
              }
          };
  
    const convertFileToBase64 = (file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64(reader.result);
        // console.log("base64",reader.result)
      };
      reader.readAsDataURL(file);
    };
  
    const sign = localStorage.getItem("sign");
  
    const [loadingSend, setLoadingSend] = useState(false)
    
    const sendBulkEmail = async () => {
       setLoadingSend(true)   
      const body = {
        "subject": subject,
        "attachment":attachment,
         "fileName":fileName,
        "others":
          // [
          // {
          //   "name": "",
          //   "email": ""
          // }
          bccEmail, 
        // ],
        "mailBody":emailBody
  
      };
      const token = localStorage.getItem('token');
      Api(`email/send_bulk_mail`, 'POST', body, token)
        .then((response) => {
          // console.log('====rec ====', response);
          if (response.status === 200) {
             handleCloseModal()
                      toast.success(response.data.message);
                       setLoadingSend(false)   
          }
        })
        .catch((err) => {
          toast.error(err, +'!');
        });
    };

    const [tempList, setTempList] = useState([])
      
       const getTemplList = () => {
          const token = localStorage.getItem('token');
          // console.log("token ===>>>>> ",token)
          Api('email/getEmailTemplateList', 'GET', '', token)
            .then((response) => {
              // console.log('Response:---------', response);
              if (response.status === 200) {
                if (response.data.code === 200) {
                  //  console.log("hhh")
      
                } else {
                  // console.log('data:', response.data.message);
                }
              }
              setTempList(response.data.result);
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        };
    
       const handleTemplateSelect = (item) => {
        if (item && item.template && item.template.length > 0) {
          setGreeting(item.template[0].greeting)
          setSubject(item.template[0].subject)
          setEmailBody(item.template[0].emailBody)
        }
      };

  return (
    <>
      <ToastContainer />

      <Helmet>
        <title> Resume Database | Foxearch </title>
      </Helmet>

      {/* <Box
        sx={{
          border: '1px solid black',
          borderRadius: '13px',
          padding: '0.7rem',
        }}
      > */}

      <div>
        <div className='mob_search'>
          <FormControl size="small" sx={{
            width: '100%',
            // borderRadius: '10px',
            border: "none",
            marginLeft: '4px',
            backgroundColor: "white",
            // border: '1px solid "#3C6BA5"', 
            // border: '1px solid #1E74B3',
            overflow: 'hidden',
            marginTop: -18,
          }}>
            <Select
              value={selectedDropdownValue}
              onChange={handleChangeDrop}
              size="small"
              className='dash_sr'
              sx={{
                borderRadius: '10px',
                border: '1px solid #1E74B3',
                '&:focus-visible': {
                  borderRadius: '10px',
                  border: '1px solid #1E74B3',
                },
              }}

              MenuProps={{
                disableScrollLock: true,
              }}
            >
              <MenuItem value='foxearchDB'>Foxearch DB</MenuItem>
              <MenuItem value='vendor'>Vendors Hotlist</MenuItem>
              <MenuItem value='monster' disabled>Monster</MenuItem>
              <MenuItem value='career' disabled>Career Builder</MenuItem>
              <MenuItem value='dice' disabled>Dice</MenuItem>
              <MenuItem value='resume' disabled>Resume Library</MenuItem>
              <MenuItem value='integrated' disabled>Integrated</MenuItem>
            </Select>
          </FormControl>

          <Button color="custom" variant="contained" size="small"
            sx={{ ml: 1.6, mt: -18 }}
            onClick={Funcc}
          >
            Search
          </Button>
        </div>
      </div>
      <Stack direction="row" alignItems="flex-end" justifyContent="space-between" >
        <Typography variant="h5" color={'text.secondary'}
       
        >
          Database Search
        </Typography>

      </Stack>

      {/* <Stack flexDirection={'row'} justifyContent={'space-between'} mb={1}>

        <Stack sx={{ flexDirection: 'row', gap: 2, cursor: 'pointer', alignItems: 'center' }}>

          <Stack
            sx={[
              { flexDirection: 'row', alignItems: 'center' },
              value === 'foxearchDB' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
            ]}
            onClick={() => handleTab('foxearchDB')}
          >
            
            <Typography variant="tabs">
              Foxearch DB
            </Typography>
          </Stack>

          <Stack
            sx={[
              { flexDirection: 'row', ml: 1, alignItems: 'center' },
              value === 'vendor' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
            ]}
            onClick={() => handleTab('vendor')}
          >
            
            <Typography variant="tabs" sx={{}}>
              Vendors Hotlist
            </Typography>
          </Stack>

          <Stack
            sx={[
              { flexDirection: 'row', ml: 1, alignItems: 'center' },
              value === 'monster' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
            ]}
          
          >
            
            <Typography variant="tabs" sx={{}}>
              Monster
            </Typography>
          </Stack>

          <Stack
            sx={[
              { flexDirection: 'row', ml: 1, alignItems: 'center' },
              value === 'career' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
            ]}
          
          >
            
            <Typography variant="tabs" sx={{}}>
              Career Builder
            </Typography>
          </Stack>

          <Stack
            sx={[
              { flexDirection: 'row', ml: 1, alignItems: 'center' },
              value === 'dice' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
            ]}
          
          >
            
            <Typography variant="tabs" sx={{}}>
              Dice
            </Typography>
          </Stack>

          <Stack
            sx={[
              { flexDirection: 'row', ml: 1, alignItems: 'center' },
              value === 'resume' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
            ]}
         
          >
            
            <Typography variant="tabs" sx={{}}>
              Resume Library
            </Typography>
          </Stack>

          <Stack
            sx={[
              { flexDirection: 'row', ml: 1, alignItems: 'center' },
              value === 'intergrated' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
            ]}
          
          >
         
            <Typography variant="tabs" sx={{}}>
              Intergrated
            </Typography>
          </Stack>
        </Stack>

      </Stack> */}

 <Stack flexDirection="row" justifyContent="space-between" mb={1}>
      
      <Box
        sx={{
          overflowX: { xs: 'auto', sm: 'visible' },
          overflowY: 'hidden',
          whiteSpace: { xs: 'nowrap', sm: 'normal' },
          width: '100%',
        }}
      > 
        <Stack
          sx={{
            flexDirection: 'row',
            gap: 2,
            cursor: 'pointer',
            alignItems: 'center',
            width: { xs: 'max-content', sm: '100%' },
          }}
        >
    
          <Stack
            sx={[
              { flexDirection: 'row', alignItems: 'center' },
              value === 'foxearchDB'
                ? { borderBottom: 3, color: 'text.secondary' }
                : { color: 'text.textG' },
            ]}
            onClick={() => handleTab('foxearchDB')}
          >
            <Typography variant="tabs">Foxearch DB</Typography>
          </Stack>

          <Stack
            sx={[
              { flexDirection: 'row', ml: 1, alignItems: 'center' },
              value === 'vendor'
                ? { borderBottom: 3, color: 'text.secondary' }
                : { color: 'text.textG' },
            ]}
            onClick={() => handleTab('vendor')}
          >
            <Typography variant="tabs">Vendors Hotlist</Typography>
          </Stack>

          <Stack
            sx={[
              { flexDirection: 'row', ml: 1, alignItems: 'center' },
              value === 'monster'
                ? { borderBottom: 3, color: 'text.secondary' }
                : { color: 'text.textG' },
            ]}
            // onClick={() => handleTab('monster')}
          >
            <Typography variant="tabs">Monster</Typography>
          </Stack>

          <Stack
            sx={[
              { flexDirection: 'row', ml: 1, alignItems: 'center' },
              value === 'career'
                ? { borderBottom: 3, color: 'text.secondary' }
                : { color: 'text.textG' },
            ]}
            // onClick={() => handleTab('career')}
          >
            <Typography variant="tabs">Career Builder</Typography>
          </Stack>

          <Stack
            sx={[
              { flexDirection: 'row', ml: 1, alignItems: 'center' },
              value === 'dice'
                ? { borderBottom: 3, color: 'text.secondary' }
                : { color: 'text.textG' },
            ]}
            // onClick={() => handleTab('dice')}
          >
            <Typography variant="tabs">Dice</Typography>
          </Stack>

          <Stack
            sx={[
              { flexDirection: 'row', ml: 1, alignItems: 'center' },
              value === 'resume'
                ? { borderBottom: 3, color: 'text.secondary' }
                : { color: 'text.textG' },
            ]}
            // onClick={() => handleTab('resume')}
          >
            <Typography variant="tabs">Resume Library</Typography>
          </Stack>

          <Stack
            sx={[
              { flexDirection: 'row', ml: 1, alignItems: 'center' },
              value === 'intergrated'
                ? { borderBottom: 3, color: 'text.secondary' }
                : { color: 'text.textG' },
            ]}
            // onClick={() => handleTab('intergrated')}
          >
            <Typography variant="tabs">Intergrated</Typography>
          </Stack>
        </Stack>
      </Box>
    </Stack>

      <Divider sx={{ borderBottomWidth: 3, borderColor: "#1E74B3" }} />
      <Box
        sx={{
          border: '3px solid #1E74B3',
          // borderRadius: '9px',
          borderTopLeftRadius: '9px',
          borderTopRightRadius: '9px',
          // padding: '0.5rem',
          paddingLeft: '0.5rem',
          paddingTop: '0.5rem',
          paddingRight: '0.5rem',
          paddingBottom: '0.5rem',
          mt: 1,
          backgroundColor: "#024C81"
        }}
      >
        <Typography sx={{ textAlign: 'center', color: "white", fontWeight: "bold", fontSize: "15px" }}>
          {value === 'foxearchDB' ? "Candidate Search" : "Consultant Search"}
        </Typography>
        {advaSearch ? (
          <>
            <Grid container spacing={3} sx={{ paddingLeft: 2, paddingRight: 3, paddingTop: 1 }}>

              {/* <Grid item xs={6} sm={8}>
                  <Autocomplete
                    multiple
                    size="small"
                    // id="job-title-autocomplete"
                    options={values?.jobTitle}
                    value={values?.jobTitle}
                    onChange={(e, newValue) => setValues({ ...values, jobTitle: newValue })}
                    // onKeyDown={(e) => {
                    //   if (e.key === 'Enter') {
                    //     e.preventDefault();
                    //     handleSearch();
                    //     funcc();
                    //     // alert("hi")
                    //   }

                    // }}
                    filterSelectedOptions
                    filterOptions={(options, params) => {
                      const inputValue = params?.inputValue?.trim()?.toLowerCase();

                      if (inputValue !== '' && !options?.some((option) => option?.toLowerCase() === inputValue)) {
                        options?.push(inputValue);
                      }

                      return options?.filter((option) =>
                        option?.toLowerCase()?.includes(inputValue)
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Job Titles"
                        variant="outlined"
                        fullWidth
                        size="small"
                        placeholder="Search or enter job titles"
                        sx={{
                          backgroundColor: "white",
                          borderRadius: "9px",
                          border: '3px solid #1E74B3'
                        }}
                        InputLabelProps={{
                          style: { color: 'black' }
                        }}
                      />
                    )}
                  />
                </Grid> */}
              <Grid item xs={4.5} >
                <Autocomplete
                  multiple
                  size="small"
                  // id="job-title-autocomplete"
                  options={values?.jobTitle}
                  value={values?.jobTitle}
                  onChange={(e, newValue) => setValues({ ...values, jobTitle: newValue })}
                  // onKeyDown={(e) => {
                  //   if (e.key === 'Enter') {
                  //     e.preventDefault();
                  //     handleSearch();
                  //     funcc();
                  //     // alert("hi")
                  //   }

                  // }}
                  filterSelectedOptions
                  filterOptions={(options, params) => {
                    const inputValue = params?.inputValue?.trim()?.toLowerCase();

                    if (inputValue !== '' && !options?.some((option) => option?.toLowerCase() === inputValue)) {
                      options?.push(inputValue);
                    }

                    return options?.filter((option) =>
                      option?.toLowerCase()?.includes(inputValue)
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // label="Job Titles"
                      variant="outlined"
                      fullWidth
                      size="small"
                      placeholder="Search OR Enter Job Titles"
                      sx={{
                        backgroundColor: "white",
                        borderRadius: "9px",
                        border: '3px solid #1E74B3'
                      }}
                      InputLabelProps={{
                        style: { color: 'black' }
                      }}
                    />
                  )}
                />
              </Grid>


              <Grid item xs={5.4} sx={{ marginTop: "1px" }}>

                <TextField
                  value={values?.skills}
                  onChange={(e) => setValues({ ...values, skills: e.target.value })}
                  // label="Skills"
                  variant="outlined"
                  fullWidth
                  size="small"
                  placeholder="Skills ( Boolean )"
                  // placeholder="Skill 1 AND Skill 2 AND (Skill 3 or Skill 4)"
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "9px",
                    border: '3px solid #1E74B3'
                  }}
                  InputLabelProps={{
                    style: { color: 'black' }
                  }}

                />
              </Grid>

              {/* <Autocomplete
  disablePortal
  variant="outlined"
  fullWidth
  size="small"
  options={visalist}
  value={values.visa}
  sx={{
    width: '18%',
    ml: 3.7,
    mt: 4.2,
    backgroundColor: 'white',
    borderRadius: '9px',
    border: '3px solid #1E74B3'
  }}
  onChange={(e) => {
    setValues({ ...values, visa: e.target.innerText });
  }}
  renderInput={(params) => (
    <TextField {...params} placeholder="Visa" />
  )}
/> */}

              <Grid item xs={2} sx={{ mb: -1.3 }}>
                <Button
                  sx={{

                    backgroundColor: "white",
                    borderRadius: "9px",
                    border: '3px solid #1E74B3',
                    color: 'green',
                    width: '115%',
                    '&:hover': {
                      backgroundColor: 'white',
                      color: 'green',
                      border: '3px solid #1E74B3',
                    },
                    '& .MuiButton-root': {
                      textTransform: 'none',
                    },
                  }}
                  disabled={!searchEnabled}

                  onClick={() => handleSearch()}>
                  Search
                </Button>
              </Grid>
            </Grid>

            <IconButton sx={{ marginLeft: "50%", mb: -1.2 }}
              onClick={() => setAdvaSearch(prevChecked => !prevChecked)}
            >
              <Iconify
                icon="bxs:down-arrow"
                color="white"
              />
            </IconButton>
          </>
        ) : (
          <>
            <Grid container spacing={3} sx={{ p: 1 }}>
              <Grid item xs={5} >

                <Autocomplete
                  multiple
                  size="small"
                  // id="job-title-autocomplete"
                  options={values?.jobTitle}
                  value={values?.jobTitle}
                  onChange={(e, newValue) => setValues({ ...values, jobTitle: newValue })}
                  // onKeyDown={(e) => {
                  //   if (e.key === 'Enter') {
                  //     e.preventDefault();
                  //     handleSearch();
                  //     funcc();
                  //     // alert("hi")
                  //   }

                  // }}
                  filterSelectedOptions
                  filterOptions={(options, params) => {
                    const inputValue = params?.inputValue?.trim()?.toLowerCase();

                    if (inputValue !== '' && !options?.some((option) => option?.toLowerCase() === inputValue)) {
                      options?.push(inputValue);
                    }

                    return options?.filter((option) =>
                      option?.toLowerCase()?.includes(inputValue)
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // label="Job Titles"
                      variant="outlined"
                      fullWidth
                      size="small"
                      placeholder="Search OR Enter Job Titles"
                      sx={{
                        backgroundColor: "white",
                        borderRadius: "9px",
                        border: '3px solid #1E74B3'
                      }}
                      InputLabelProps={{
                        style: { color: 'black' }
                      }}
                    />
                  )}
                />

                {/* <TextField
                  value={values?.jobTitle}
                  onChange={(e) => setValues({ ...values, jobTitle: e.target.value })}
                  // label="Job Titles"
                  variant="outlined"
                  fullWidth
                  size="small"
                  placeholder="Job titles"
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "9px",
                    border: '3px solid #1E74B3'
                  }}
                  InputLabelProps={{
                    style: { color: 'black' }
                  }}
                /> */}
              </Grid>

              <Grid item xs={7} sx={{ marginTop: "1px" }}>
                {/* <Autocomplete
                    multiple
                    id="tags-outlined"
                    size="small"
                    // width="100%"
                    // backgroundColor="white"
                    options={skillLst}
                    getOptionLabel={(option) => option?.title}
                    onChange={(event, newValue) => {
                      const skillsOnly = newValue?.map((item) => item?.title);
                      setValues({ ...values, skills: skillsOnly });

                    }}
                    // onKeyDown={(e) => {
                    //   if (e.key === 'Enter') {
                    //     e.preventDefault();
                    //     handleSearch();
                    //     funcc();
                    //     // alert("hi")
                    //   }

                    // }}
                    // value={values?.skills?.map((skill) => ({ title: skill }))}
                    filterSelectedOptions
                    filterOptions={(options, params) => {
                      const filtered = options?.filter((option) =>
                        option?.title?.toLowerCase()?.includes(params?.inputValue?.toLowerCase())
                      );

                      const { inputValue } = params;
                      if (inputValue !== '' && !options?.some((option) => option?.title === inputValue)) {
                        filtered?.push({ title: inputValue });
                      }

                      return filtered;
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Skills"
                        placeholder="Select or type to add skills"
                        sx={{
                          backgroundColor: "white",
                          borderRadius: "9px",
                          border: '3px solid #1E74B3'
                        }}
                        InputLabelProps={{
                          style: { color: 'black' }
                        }}
                      />

                    )}
                  /> */}
                <TextField
                  value={values?.skills}
                  onChange={(e) => setValues({ ...values, skills: e.target.value })}
                  // label="Skills"
                  variant="outlined"
                  fullWidth
                  size="small"
                  placeholder="Skills ( Boolean )"
                  // placeholder="Skill 1 AND Skill 2 AND (Skill 3 or Skill 4)"
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "9px",
                    border: '3px solid #1E74B3'
                  }}
                  InputLabelProps={{
                    style: { color: 'black' }
                  }}
                />
              </Grid>

              {/* <Autocomplete
  // disablePortal
  variant="outlined"
  fullWidth
  size="small"
  options={visalist}
  value={values.visa}
  sx={{
    width: '14%',
    ml: 3.7,
    mt: 4.2,
    backgroundColor: 'white',
    borderRadius: '9px',
    border: '3px solid #1E74B3',
    height:"42px"
  }}
  onChange={(e) => {
    setValues({ ...values, visa: e.target.innerText });
  }}
  renderInput={(params) => (
    <TextField {...params} placeholder="Visa" />
  )}
/> */}

              {/* <IconButton sx={{ }} 
            // onClick={showPep}
            >
              <Iconify
                icon="bxs:down-arrow"
                color="white"
              />
            </IconButton> */}
              <Grid item xs={6} sm={1.68}>
                <Autocomplete
                  disablePortal
                  variant="outlined"
                  fullWidth
                  size="small"
                  options={visalist}
                  value={values.visa}
                  sx={{
                    // width: '18%',
                    // ml: 3.7,
                    // mt: 4.2,
                    backgroundColor: 'white',
                    borderRadius: '9px',
                    border: '3px solid #1E74B3'
                  }}
                  onChange={(e) => {
                    setValues({ ...values, visa: e.target.innerText });
                  }}
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Visa" />
                  )}
                />
              </Grid>
              <Grid item xs={6} sm={1.68}>
                <FormControl fullWidth variant="outlined" size="small"
                // sx={{ backgroundColor: "white", borderRadius: "9px", border: '3px solid #1E74B3' }}
                >
                  <InputLabel sx={{ color: "black", paddingTop: 0.2 }}>Country</InputLabel>
                  <Select
                    // label="Country"
                    // placeholder='Country'
                    // defaultValue=""
                    value={values?.country}
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "9px",
                      border: '3px solid #1E74B3',
                    }}
                    onChange={(e) => { 
                      // setCountryReq(true); 
                      setValues({ ...values, country: e.target.value }) }}
                  >

                    {/* <MenuItem value="USA">USA</MenuItem>
                    <MenuItem value="CANADA">CANADA</MenuItem>
                     <MenuItem value={'INDIA'}>INDIA</MenuItem>; */}
                     {countries?.map((item) => (
      <MenuItem key={item.id} value={item.country}>
        {item.country}
      </MenuItem>
    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={1.65}>
                <CustomCompleteResumeDatabaseCity

                  // placeholder={'City'}
                  size="small"
                  option={cityData}
                  propVal={cityQuery}
                  childFuc={childFuc}
                  fetch={'state'}
                  err={err}
                  helperText={helperText}
                />
              </Grid>
              <Grid item xs={6} sm={1.7}>

                <CustomCompletesResumeDatabaseState
                  //  placeholder={'State'}
                  size="small"
                  option={stateData}
                  propVal={stateQuery}
                  childFuc={childFucState}
                  err={err}
                  helperText={helperText}
                />
              </Grid>
              <Grid item xs={6} sm={1.7}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel sx={{ color: "black", paddingTop: 0.2 }}>Distance</InputLabel>
                  <Select
                    // label="Distance"
                    value={values?.distance}
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "9px",
                      border: '3px solid #1E74B3',
                      color: "black",
                      '& .MuiSelect-icon': {
                        color: "black",

                      },
                      // '& .MuiOutlinedInput-notchedOutline': {
                      //   borderColor: '#1E74B3', 
                      // },
                    }}
                    onChange={(e) => setValues({ ...values, distance: e.target.value })}
                  >
                    <MenuItem value="10" sx={{ color: "black" }}>10 Miles</MenuItem>
                    <MenuItem value="20" sx={{ color: "black" }}>20 Miles</MenuItem>
                    <MenuItem value="40" sx={{ color: "black" }}>40 Miles</MenuItem>
                    <MenuItem value="50" sx={{ color: "black" }}>50 Miles</MenuItem>
                    <MenuItem value="100" sx={{ color: "black" }}>100 Miles</MenuItem>
                    <MenuItem value="500" sx={{ color: "black" }}>500 Miles</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={1.7}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel sx={{ color: "black", paddingTop: 0.2 }}>Relocation</InputLabel>
                  <Select
                    // label="Distance"
                    value={values?.relocation}
                    sx={{
                      backgroundColor: "white",
                      borderRadius: "9px",
                      border: '3px solid #1E74B3',
                      color: "black",
                      '& .MuiSelect-icon': {
                        color: "black",

                      },
                      // '& .MuiOutlinedInput-notchedOutline': {
                      //   borderColor: '#1E74B3',
                      // },
                    }}
                    onChange={(e) => setValues({ ...values, relocation: e.target.value })}
                  >
                    <MenuItem value="yes">Yes</MenuItem>
                    <MenuItem value="no">No</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6} sm={1.88}>
                <Button
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "9px",
                    border: '3px solid #1E74B3',
                    color: 'green',
                    width: '100%',
                    '&:hover': {
                      backgroundColor: 'white',
                      color: 'green',
                      border: '3px solid #1E74B3',
                    },
                    '& .MuiButton-root': {
                      textTransform: 'none',
                    },
                  }}
                  disabled={!searchEnabled}
                  onClick={() => handleSearch()}>
                  Search
                </Button>
              </Grid>

            </Grid>

            <IconButton sx={{ marginLeft: "50%", mt: -1.2, mb: -0.9 }}
              onClick={() => setAdvaSearch(prevChecked => !prevChecked)}
            >
              <Iconify
                icon="bxs:up-arrow"
                color="white"
              />
            </IconButton>
          </>
        )}
        {value === "foxearchDB" && search || value === "vendor" && vendorSearch ? (
          <Box sx={{display:"flex",flexDirection:"row",justifyContent:"end",marginTop:"-15px"}}>
            <Grid item xs={6} sm={2} >
              <FormControlLabel
                control={
                  // <Checkbox
                  //   checked={checked}
                  //   onChange={handleChecked}
                  //   sx={{

                  //     color: pink[800],
                  //     '&.Mui-checked': {
                  //       color: pink[600],
                  //     },
                  //     padding: 0.2,
                  //   }}
                  // />
                  <Checkbox
                    checked={checked}
                    onChange={handleChecked}
                    sx={{
                      color: 'green',
                      '&.Mui-checked': {
                        color: 'green',
                      },
                      padding: 0,
                      margin:0
                    }}
                  />

                }
                label="Save Search"
                sx={{ color: 'white', fontSize: '13px' }}
              />
            </Grid>
            <Grid item xs={6} sm={4}>
              <Button
                sx={{
                  backgroundColor: "white",
                  borderRadius: "4px",
                  // border: '3px solid #1E74B3',
                  color: 'red',
                  // width: 'auto',
                  // padding: '0.01px 0.01px',
                  lineHeight: "4.2px",
                  textAlign:"end",

                  '&:hover': {
                    backgroundColor: 'white',
                    // color: 'red',
                    // border: '3px solid #1E74B3',
                  },
                  '& .MuiButton-root': {
                    textTransform: 'none',
                  },
                }}
                onClick={() => clearAll()}>
                Clear
              </Button>
            </Grid>
          </Box>
        ) : (
          <>
            <Grid item xs={6} sm={4} sx={{}}>
              <Button
                sx={{
                  backgroundColor: "white",
                  borderRadius: "4px",
                  // border: '3px solid #1E74B3',
                  color: 'red',
                  // width: 'auto',
                  // padding: '0.1px 0.1px',
                  ml: "87%",
                  lineHeight: "4.2px",

                  marginTop: "-43px",

                  '&:hover': {
                    backgroundColor: 'white',
                    // color: 'red',
                    // border: '3px solid #1E74B3',
                  },
                  '& .MuiButton-root': {
                    textTransform: 'none',
                  },
                }}
                onClick={() => clearAll()}>
                Clear
              </Button>
            </Grid>
            {totalHide && (

              <Typography sx={{ ml: "93.6%", fontWeight: "bold", color: "white", mt: -4.9, mb: 1 }}>Total - {total}</Typography>
            )}
          </>
        )}

      </Box>
      <Box
        sx={{
          border: '3px solid #1E74B3',
          // borderLeft: '3px solid #1E74B3',
          // borderRight: '3px solid #1E74B3',
          // borderBottom: '3px solid #1E74B3',
          // borderTop: '3px solid #1E74B3',
          // borderRadius: '9px',
          borderBottomLeftRadius: '9px',
          borderBottomRightRadius: '9px',
          padding: '1rem',
          // paddingBottom:"1.5rem",
          // mt: -0.6,
          // mt: -2,
          mt: (value === "foxearchDB" && search ||
            value === "vendor" && vendorSearch ||
            loading === "No data found"
          ) ? -1 : -0.4,
          // m:2,
          backgroundColor: "white",
          width: "100%"
        }}
      >
        {(value === "foxearchDB" && search) ? (
          <>
            {/* <Typography color={'text.secondary'} */}
            <Typography
              sx={{ mt: 1.7, mb: 0.5, fontWeight: "bold" }}>
              Search History
            </Typography>
            <Divider sx={{ border: '0.4px solid #B0B0B0', mb:1 }} />

            {searchData
              ?.filter(item => item !== null && item !== undefined && item !== "" && item !== 0)
              ?.slice(0, visibleItems)
              ?.map((item, index) => (
                <p key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                  <Typography
                    sx={{
                      // fontSize: '15px',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      marginRight: '10px',
                      textDecoration: 'none',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >

                    {(item?.jobTitle.length || item?.city || item?.state || item?.relocation || item?.skill?.length || item?.country) && (
                      <>
                        {/* {' | '} */}
                        <span>
                          {`${new Date(item?.createdAt).toLocaleString('en-US', optionsDate)} 
              ${String(new Date(item?.createdAt).getHours()).padStart(2, '0')}:${String(new Date(item?.createdAt).getMinutes()).padStart(2, '0')}`}
                        </span>
                      </>
                    )}
                  </Typography>

                  <div
                    onClick={() => { setAutoSearch(true); foxDBSearchAuto(item, '') }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        setAutoSearch(true); foxDBSearchAuto(item, '');
                      }
                    }}
                    role="button"
                    tabIndex="0"
                    style={{
                      cursor: 'pointer',
                      color: '#15c',
                      textTransform: 'capitalize',
                      transition: 'background-color 0.3s ease',
                      textDecoration: "underline"
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = tablebg;
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = '';
                    }}
                  >
                    {item?.jobTitle.length > 0 && (
                      <>
                        <span>{item.jobTitle.join(', ')}</span>
                        {item?.skill?.length > 0 || item?.country || item?.city || item?.distance || item?.relocation || item?.visaType ? ' | ' : ''}
                      </>
                    )}

                    {item?.skill && (
                      <>
                        <span>{item.skill}</span>
                        {item?.country || item?.city || item?.distance || item?.relocation || item?.visaType ? ' | ' : ''}
                      </>
                    )}

                    {item?.country && (
                      <>
                        <span>{item.country}</span>
                        {item?.city || item?.distance || item?.relocation || item?.visaType ? ' | ' : ''}
                      </>
                    )}

                    {item?.city && (
                      <>
                        <span>{item.city}, {item.state}</span>
                        {item?.distance || item?.relocation || item?.visaType ? ' | ' : ''}
                      </>
                    )}

                    {item?.distance && (
                      <>
                        <span style={{ textTransform: 'lowercase' }}>within</span> <span>{item.distance}</span> <span style={{ textTransform: 'lowercase' }}>miles</span>
                        {item?.relocation || item?.visaType ? ' | ' : ''}
                      </>
                    )}

                    {item?.relocation && (
                      <>
                        <span>Relo - {item.relocation}</span>
                        {item?.visaType && ' | '}
                      </>
                    )}

                    {item?.visaType && <span>{item.visaType}</span>}
                  </div>


                  {/* <IconButton
                                                                                      sx={{
                                                                                         
                                                                                          width: 25,
                                                                                          height: 25,
                                                                                          ml:"10px",
                                                                                          backgroundColor: 'lightgrey',
                                                                                          borderRadius: '50%',
                                                                                          padding: 0,
                                                                                          '&:hover': {
                                                                                              backgroundColor: 'grey',
                                                                                          },
                                                                                      }}
                                                                                  >
                                                                                      {item?.countDocumemt || '0'}
                                                                                  </IconButton> */}
                  <Typography sx={{ ml: 1.8, color: "#5e5a5a" }}>
                    Total Result : {item?.countDocumemt || 0}
                  </Typography>
                </p>
              ))}


            <div style={{ display: 'flex', justifyContent: 'center' }}>

              {showAll ? <IconButton sx={{}}
                onClick={handleToggle}
              >
                <Iconify
                  icon="bxs:up-arrow"
                // color="white"
                />
              </IconButton> : <IconButton sx={{}}
                onClick={handleToggle}
              >
                <Iconify
                  icon="bxs:down-arrow"
                // color="white"
                />
              </IconButton>}

            </div>


            <Typography
              sx={{ mt: 1, mb: 0.5, fontWeight: "bold" }}>
              Saved Searches
            </Typography>
            <Divider sx={{ border: '0.4px solid #B0B0B0' }} />

            {displayedItems?.map((item, index) => (
              <div key={index} style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                {(item?.jobTitle || item?.city || item?.state || item?.relocation || item?.skill?.length || item?.country) && (
                  <Typography sx={{ display: 'flex', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', marginRight: "10px" }}>
                    <span>
                      {`${new Date(item?.createdAt).toLocaleString('en-US', optionsDate)} 
          ${String(new Date(item?.createdAt).getHours()).padStart(2, '0')}:${String(new Date(item?.createdAt).getMinutes()).padStart(2, '0')}`}
                    </span>
                  </Typography>
                )}


                <div
                  onClick={() => { setAutoSearch(true); foxDBSearchAuto(item, '') }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      setAutoSearch(true); foxDBSearchAuto(item, '');
                    }
                  }}
                  role="button"
                  tabIndex="0"
                  style={{
                    cursor: 'pointer',
                    color: '#15c',
                    textTransform: 'capitalize',
                    transition: 'background-color 0.3s ease',
                    textDecoration: "underline"
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = tablebg;
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '';
                  }}
                >
                  <Typography sx={{ color: '#15c', textTransform: 'capitalize' }}>
                    {item?.jobTitle?.length > 0 && (
                      <>
                        <span>{item.jobTitle.join(', ')}</span>
                        {(item?.skill || item?.country || item?.city || item?.distance || item?.relocation || item?.visaType) ? ' | ' : ''}
                      </>
                    )}

                    {item?.skill && (
                      <>
                        <span>{item.skill}</span>
                        {(item?.country || item?.city || item?.distance || item?.relocation || item?.visaType) ? ' | ' : ''}
                      </>
                    )}

                    {item?.country && (
                      <>
                        <span>{item.country}</span>
                        {(item?.city || item?.distance || item?.relocation || item?.visaType) ? ' | ' : ''}
                      </>
                    )}

                    {item?.city && (
                      <>
                        <span>{item.city}, {item.state}</span>
                        {(item?.distance || item?.relocation || item?.visaType) ? ' | ' : ''}
                      </>
                    )}

                    {item?.distance && (
                      <>
                        <span style={{ textTransform: 'lowercase' }}>within</span> <span>{item.distance}</span> <span style={{ textTransform: 'lowercase' }}>miles</span>
                        {item?.relocation || item?.visaType ? ' | ' : ''}
                      </>
                    )}

                    {item?.relocation && (
                      <>
                        <span>Relo - {item.relocation}</span>
                        {item?.visaType && ' | '}
                      </>
                    )}

                    {item?.visaType && <span>{item.visaType}</span>}
                  </Typography>
                </div>

                {/* <IconButton
                                                                                      sx={{
                                                                                         
                                                                                          width: 25,
                                                                                          height: 25,
                                                                                          ml:"10px",
                                                                                          backgroundColor: 'lightgrey',
                                                                                          borderRadius: '50%',
                                                                                          padding: 0,
                                                                                          '&:hover': {
                                                                                              backgroundColor: 'grey',
                                                                                          },
                                                                                      }}
                                                                                  >
                                                                                      {item?.countDocumemt || '0'}
                                                                                  </IconButton> */}
                <Typography sx={{ ml: 1.8, color: "#5e5a5a" }}>
                  Total Result : {item?.countDocumemt || 0}
                </Typography>
              </div>
            ))}

            <div style={{ display: 'flex', justifyContent: 'center' }}>

              {showAll1 ? <IconButton sx={{}}
                onClick={handleToggle1}
              >
                <Iconify
                  icon="bxs:up-arrow"
                // color="white"
                />
              </IconButton> : <IconButton sx={{}}
                onClick={handleToggle1}
              >
                <Iconify
                  icon="bxs:down-arrow"
                // color="white"
                />
              </IconButton>}

            </div>

          </>
        ) : (value === "foxearchDB" && !search) && (
          (foxSearch?.length > 0 ? (

            // <Box
            //   sx={{
            //     // border: '3px solid #1E74B3',
            //     borderLeft: '3px solid #1E74B3',
            //     borderRight: '3px solid #1E74B3',
            //     borderBottom: '3px solid #1E74B3',
            //     borderTop: '3px solid #1E74B3',
            //     // borderRadius: '9px',
            //     borderBottomLeftRadius: '9px',
            //     borderBottomRightRadius: '9px',
            //     padding: '1rem',
            //     mt: -0.6,
            //     // m:2,
            //     backgroundColor: "white",
            //     width: "100%" 
            //   }}
            // >
            <>

              <Stack sx={{ flexDirection: 'row' }}>

                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                  <Grid item xs={6} >
                    {foxSearch?.map((item, index) => (
                      <Grid container item xs={12} spacing={2} key={index} sx={{ mb: 1.7 }}>

                        <Grid item xs={12}

                        >
                          <Box
                            sx={{
                              border: "2px solid rgb(164 176 191)",
                              borderRadius: '9px',
                              padding: '1rem',
                              backgroundColor: !checkedStates[item?._id]
                                ? (index % 2 === 0 ? 'text.background' : tablebg)
                                : tablebg,
                              width: '105%',
                              cursor: "pointer"
                            }}

                            onClick={() =>
                              setResumeUrl(item?.recruitorAppId?.resumeUrl)}

                          >
                            <Grid container spacing={0.1} alignItems="center" sx={{ justifyContent: 'space-between' }}

                            >

                              <Grid
                                item
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",

                                  ml: -0.9,
                                  mt: -1,
                                  mr: -3,
                                }}
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={checkedStates[item?._id] || false}
                                      onChange={() => handleCheckedSearch(item?._id, item?.recruitorAppId?.email, item?.recruitorAppId?.fullName)}
                                    />
                                  }
                                  label=""
                                />
                                <Iconify icon="fluent:prohibited-32-regular" width="1.4rem" color="red" sx={{ ml: -0.1 }}
                                  onClick={() => confirmOpenDelete(item?._id)} />
                              </Grid>

                              <Grid item xs={3.7}>
                                <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                  <Typography
                                    color={'text.secondary'}
                                    sx={{
                                      fontSize: '15px',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      fontWeight: 'bold',
                                      // flex: 1,
                                      maxWidth: 150,
                                      textTransform: 'capitalize',
                                      // color: "#5e5a5a"
                                    }}
                                  >
                                    {item?.recruitorAppId?.fullName ? item?.recruitorAppId?.fullName : '-'}
                                  </Typography>

                                  {item?.recruitorAppId?.fullName && (
                                    <Iconify
                                      icon="devicon:linkedin"
                                      color={'text.textG'}
                                      sx={{
                                        height: 15,
                                        width: 15,
                                        cursor: 'pointer',
                                        ml: 1,
                                      }}
                                      onClick={() => window?.open(item?.recruitorAppId?.linkedinUrl, '_blank')}
                                    />
                                  )}
                                </div>
                                <Typography
                                  color="#5e5a5a"
                                  sx={{
                                    fontSize: '15px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: 'flex',
                                    alignItems: 'center',

                                  }}
                                >
                                  Up -{" "}
                                  <span
                                    style={{
                                      color: '#5e5a5a',
                                      fontWeight: 'normal',
                                      marginLeft: '5px',
                                      marginRight: '5px',
                                    }}
                                  >
                                    {`${new Date(item?.recruitorAppId?.updatedAt).toLocaleString('en-US', optionsDate)}`}
                                  </span>
                                </Typography>

                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <Typography
                                    // color={'text.secondary'}
                                    color="#5e5a5a"
                                    sx={{
                                      // fontWeight: 'bold',
                                      fontSize: '15px',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      // flexGrow: 1,
                                      // flex: 1,
                                      maxWidth: 150,
                                      textTransform: 'capitalize',
                                    }}
                                  >
                                    {/* Email - <span style={{ color: 'black', fontWeight: 'normal' }}>{item?.recruitorAppId?.email}</span> */}
                                    {item?.recruitorAppId?.email ? item?.recruitorAppId?.email : "-"}
                                  </Typography>
                                  {item?.recruitorAppId?.email && (

                                    <CopyToClipboard text={item?.recruitorAppId?.email} onCopy={() => setEmailCopy(true)}>
                                      <Iconify
                                        icon="radix-icons:copy"
                                        color={emailCopy ? 'text.secondary' : 'text.textG'}
                                        sx={{ height: 15, width: 15, cursor: 'pointer', ml: 1 }}
                                      />
                                    </CopyToClipboard>
                                  )}
                                </div>

                                <Typography
                                  sx={{
                                    fontSize: "15px",
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    textTransform: 'capitalize',
                                    display: 'inline',
                                  }}
                                >
                                  <span style={{ color: "#5e5a5a", fontWeight: "normal" }}>
                                    {/* {item?.recruitorAppId?.skill?.[0] ? item?.recruitorAppId?.skill?.[0] : (item?.recruitorAppId?.skill?.[1] || item?.recruitorAppId?.skill?.[2])} */}
                                    {/* {item?.recruitorAppId?.skill?.length > 1 ? '...' : '-'} */}
                                  </span>

                                  {/* {item?.recruitorAppId?.skill?.length > 1 && ( */}
                                  <span
                                    tabIndex={0}
                                    role="button"
                                    style={{
                                      color: '#1E74B3',
                                      textDecoration: 'underline',
                                      cursor: 'pointer',
                                      // marginLeft: "10px", 
                                      // textTransform: 'none'
                                    }}
                                    onClick={() => handleOpens(item?.recruitorAppId?.skill)}
                                    onKeyDown={(e) => e.key === 'Enter' && handleOpens(item?.recruitorAppId?.skill)}
                                  >
                                    Skills
                                  </span>
                                  {/* )} */}
                                </Typography>



                              </Grid>

                              <Grid item xs={3.7}>
                                <Typography
                                  // color={'text.secondary'}
                                  // color="#5e5a5a"
                                  sx={{
                                    fontWeight: 'bold',
                                    fontSize: '15px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    textTransform: 'capitalize',
                                  }}
                                >
                                  {/* Job Title - <span style={{ color: 'black', fontWeight: 'normal' }}>{item?.recruitorAppId?.jobTitle} </span> */}
                                  {item?.jobTitle ? item?.jobTitle : "-"}
                                </Typography>
                                <Typography
                                  // color={'text.secondary'}
                                  color="#5e5a5a"
                                  sx={{
                                    // fontWeight: 'bold',
                                    fontSize: '15px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    textTransform: 'capitalize',
                                  }}
                                >
                                  Visa - <span style={{ color: '#5e5a5a', fontWeight: 'normal' }}>{item?.recruitorAppId?.visaType} </span>
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <Typography
                                    // color={'text.secondary'}
                                    color="#5e5a5a"
                                    sx={{
                                      // fontWeight: 'bold',
                                      fontSize: '15px',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      // flexGrow: 1,
                                      // flex: 1, 

                                    }}
                                  >
                                    {/* Contact - <span style={{ color: 'black', fontWeight: 'normal' }}>{item?.recruitorAppId?.phone}</span> */}
                                    {item?.recruitorAppId?.phone ? item?.recruitorAppId?.phone : "-"}
                                  </Typography>
                                  {item?.recruitorAppId?.phone && (

                                    <CopyToClipboard text={item?.recruitorAppId?.phone} onCopy={() => setPhoneCopy(true)}>
                                      <Iconify
                                        icon="radix-icons:copy"
                                        color={phoneCopy ? 'text.secondary' : 'text.textG'}
                                        sx={{ height: 15, width: 15, cursor: 'pointer', ml: 1 }}
                                      />
                                    </CopyToClipboard>
                                  )}
                                </div>
                                <Typography
                                  color={'text.secondary'}
                                  sx={{
                                    // fontWeight: 'bold',
                                    fontSize: '15px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    textTransform: 'capitalize',
                                  }}
                                >
                                  Tax Term - <span style={{ color: "#5e5a5a", fontWeight: 'normal' }}>{item?.recruitorAppId?.taxTerm} </span>
                                </Typography>
                              </Grid>

                              <Grid item xs={3.7} sx={{ mr: -1 }}>
                                <Typography
                                  // color={'text.secondary'}
                                  // color="#5e5a5a"
                                  sx={{
                                    fontWeight: 'bold',
                                    fontSize: '15px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    textTransform: 'capitalize',
                                  }}
                                >
                                  {/* Current company - <span style={{ color: 'black', fontWeight: 'normal' }}>{item?.recruitorAppId?.currentCompany} </span> */}
                                  {item?.recruitorAppId?.currentCompany ? item?.recruitorAppId?.currentCompany : '-'}
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <Typography
                                    // color={'text.secondary'}
                                    color="#5e5a5a"
                                    sx={{
                                      // fontWeight: 'bold',
                                      fontSize: '15px',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      textTransform: 'capitalize',
                                      // flexGrow: 1,
                                    }}
                                  >
                                    {/* Location - <span style={{ color: 'black', fontWeight: 'normal' }}>{item?.recruitorAppId?.city}, {item?.recruitorAppId?.state}</span> */}
                                    {item?.recruitorAppId?.city}, {item?.recruitorAppId?.stateCode}
                                  </Typography>
                                  {(item?.relocation === "yes") && (
                                    <Iconify icon="mdi:aeroplane" width="1rem" color={'text.secondary'} sx={{ ml: 0.3 }} />
                                  )}   </div>
                                <Typography
                                  // color={'text.secondary'}
                                  color="#5e5a5a"
                                  sx={{
                                    // fontWeight: 'bold',
                                    fontSize: '15px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    textTransform: 'capitalize',
                                  }}
                                >
                                  Emp Type - <span style={{ color: "#5e5a5a", fontWeight: 'normal' }}>{item?.recruitorAppId?.chargeType}</span>
                                </Typography>
                                <Typography
                                  color={'text.secondary'}
                                  sx={{
                                    // fontWeight: 'bold',
                                    fontSize: '15px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    textTransform: 'capitalize',
                                  }}
                                >
                                  Salary/Rate - <span style={{ color: "#5e5a5a", fontWeight: 'normal' }}>
                                    {item?.recruitorAppId?.expectedCompensation && (
                                      <>
                                        ${item?.recruitorAppId?.expectedCompensation}
                                        {item?.recruitorAppId?.chargeType === "hourly" ? "/hour" :
                                          (item?.recruitorAppId?.chargeType === "Annually" ? 'k' : '')
                                        }
                                      </>
                                    )}

                                  </span>
                                </Typography>
                              </Grid>

                            </Grid>
                          </Box>
                        </Grid>

                      </Grid>
                    ))}
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      sx={{
                        // border: '3px solid #1E74B3',
                        border: "2px solid rgb(164 176 191)",
                        borderRadius: '9px',
                        padding: '1rem',
                        // mt: 1,
                        ml: 2.5,
                        backgroundColor: "white",
                        width: '97%',
                        // width: '43%',
                        // maxWidth: '43%',
                        // minWidth: '0',
                        maxHeight: "900px"
                      }}
                    >

                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', mt: -2.5 }}>
                        <Typography variant="h6" sx={{ textAlign: 'center', color: 'text.secondary', fontWeight: 'bold', flex: 1 }}>
                          {/* Resume */}
                        </Typography>
                        <a href={(resumeUrl?.recruitorAppId?.resumeUrl || resumeUrl)} download>
                          <Iconify icon="mdi:download" width="1.3rem" color='text.secondary' sx={{ mt: 1 }} />
                        </a>
                      </Box>
                      <Scrollbar sx={{ maxHeight: 792, Scrollbar: 'thin' }}>
                        <iframe title="resume" src={suru + (resumeUrl?.recruitorAppId?.resumeUrl || resumeUrl) + lll} width="100%" height="790px" />
                      </Scrollbar>
                    </Box>
                  </Grid>
                </Grid>

              </Stack>

              <Stack
                direction="row"
                spacing={4}
                justifyContent="center"
                alignItems="center"
                sx={{ width: '100%', mt: 4 }}
              >
                <Button
                  color="custom"
                  variant="contained"
                  sx={{ width: "18%" }}
                  disabled={Object?.values(checkedStates)?.every(value => !value)}
                  // onClick={() => addToWs()}
                  onClick={() => moveTo()}
                >
                  Add to Worksheet
                </Button>
                <Button color="custom" variant="contained" sx={{ width: "18%" }}
                   onClick={() => handleOpenModal(foxSearch[0]?.email)}>
                  Email
                </Button>
              </Stack>

              {tableCount > 6 ? (
                <Stack
                  spacing={2}
                  sx={{
                    width: '100%',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    mt: 2
                  }}
                >

                  <Button
                    variant="outlined"
                    sx={{
                      minWidth: 16, height: 32, borderRadius: '5px',
                      mt: 2,
                      ml: 0.5, cursor: 'pointer'
                    }}
                    onClick={() => setPageNumber(prev => Math.max(prev - 1, 1))}
                  >
                    {"<"}
                  </Button>

                  <Pagination
                    variant="outlined"
                    shape="rounded"
                    color="secondary"
                    hideNextButton
                    hidePrevButton
                    count={pages}
                    page={pageNumber}
                    onChange={handlePage}
                    sx={{ cursor: 'pointer', mb: (pageNumber !== 1) ? -4 : -2 }}
                  />

                  <Button
                    variant="outlined"
                    sx={{
                      minWidth: 16, height: 32, borderRadius: '5px', mr: 1,
                      mt: -2,
                      cursor: 'pointer'
                    }}
                    onClick={() => setPageNumber(prev => Math.min(prev + 1, pages))}
                  >
                    {">"}
                  </Button>

                </Stack>

              ) : null}
            </>

          ) : (
            <Typography
              style={{
                textAlign: 'center',
                color: 'red',
                mt: 5,
                mb: 2
              }}
            >
              {/* No data found */}
              {loading}
            </Typography>
          ))
        )}

        {/* vendorHotlist */}
        {(value === "vendor" && vendorSearch) ? (
          <>
            <Typography color={'text.secondary'} sx={{ textAlign: 'center', fontWeight: "bold", mt: 2, mb: 3 }}>Top Hotlist</Typography>

            <Grid container spacing={2}>
              {displayedItems1?.map((item, index) => (
                // {recBenchData?.map((item, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Box
                    sx={{
                      // border: '3px solid #1E74B3',
                      border: "2px solid rgb(164 176 191)",
                      borderRadius: '9px',
                      // padding: '1rem',
                      paddingLeft: "1rem",
                      paddingRight: "1rem",
                      // backgroundColor: "white",
                      // backgroundColor: index % 2 === 0 ? 'white' : tablebg,
                      backgroundColor: (index % 4 === 0 || index % 4 === 1) ? 'white' : tablebg
                    }}
                  >
                    <Typography color={'text.secondary'}
                      sx={{
                        textAlign: 'center', fontSize: "18px",
                        textTransform: 'capitalize', fontWeight: "bold",
                        mt: 0.4
                      }}>
                      {item?.benchAppId?.jobTitle ? item?.benchAppId?.jobTitle : '-'}
                    </Typography>
                    <Grid container spacing={4}>
                      <Grid item xs={4}>
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                          <Typography
                            // color={'text.secondary'}
                            sx={{
                              fontSize: '15px',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              fontWeight: 'bold',
                              // flex: 1,
                              maxWidth: 150,
                              textTransform: 'capitalize',
                              // color: "#5e5a5a"
                            }}
                          >
                            {item?.addedById?.contactPersonName ? item?.addedById?.contactPersonName : '-'}
                            {/* {item?.benchAppId?.fullName ? item?.benchAppId?.fullName : '-'} */}
                          </Typography>

                          {item?.addedById?.contactPersonName && (
                            <Iconify
                              icon="devicon:linkedin"
                              color={'text.textG'}
                              sx={{
                                height: 15,
                                width: 15,
                                cursor: 'pointer',
                                ml: 1,
                              }}
                              onClick={() => window?.open(item?.benchAppId?.linkedinUrl, '_blank')}
                            />
                          )}
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                          <Typography
                            sx={{
                              fontSize: '15px',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              // flex: 1,
                              maxWidth: 150,
                              textTransform: 'capitalize',
                              color: "#5e5a5a"
                            }}
                          >
                            {item?.addedById?.email ? item?.addedById?.email : '-'}
                            {/* {item?.benchAppId?.email ? item?.benchAppId?.email : '-'} */}
                          </Typography>
                          {item?.addedById?.email && (
                            <CopyToClipboard text={item?.addedById?.email} onCopy={() => setEmailCopy(true)}>
                              <Iconify
                                icon="radix-icons:copy"
                                color={emailCopy ? 'text.secondary' : 'text.textG'}
                                sx={{ height: 15, width: 15, cursor: 'pointer', ml: 1 }}
                              />
                            </CopyToClipboard>
                          )}
                        </div>

                        <Typography
                          // color={'text.secondary'}
                          sx={{
                            fontSize: "15px",
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            textTransform: 'capitalize',
                            display: 'inline',

                          }}
                        >
                          {/* <span style={{ color: "#5e5a5a", fontWeight: "normal" }}>
                            {item?.benchAppId?.skill?.slice(0, 1).join(', ')}{item?.benchAppId?.skill?.length > 1 ? '...' : '-'}
                          </span> */}
                        </Typography>
                        <Typography
                          color={'text.secondary'}
                          sx={{
                            textDecoration: 'underline',
                            cursor: 'pointer', display: 'inline',
                            //  fontWeight:"bold",
                            // fontSize:"20px"
                          }}
                          onClick={() => {
                            handleOpens(item?.benchAppId?.skill);
                          }}
                        >
                          {/* {item?.benchAppId?.skill?.length > 1 && 'skills'} */}
                          Skills
                        </Typography>

                      </Grid>

                      <Grid item xs={4}>

                        <Typography
                          sx={{
                            fontSize: '15px',
                            fontWeight: "bold",
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            textTransform: 'capitalize',
                            // color:"#5e5a5a"
                          }}
                        >
                          {item?.benchAppId?.currentCompany ? item?.benchAppId?.currentCompany : '-'}
                        </Typography>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Typography
                            // color={'text.secondary'}
                            sx={{
                              // fontWeight: "bold",
                              fontSize: "15px",
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              // flex: 1, 
                            }}>
                            {/* Contact - <span style={{ color: 'black', fontWeight: "normal" }}>{item?.contact}</span> */}
                            {item?.addedById?.contactNo ? item?.addedById?.contactNo : '-'}
                            {/* {item?.benchAppId?.phone ? item?.benchAppId?.phone : '-'} */}
                          </Typography>
                          {item?.addedById?.contactNo && (

                            <CopyToClipboard text={item?.addedById?.contactNo} onCopy={() => setPhoneCopy(true)}>
                              <Iconify
                                icon="radix-icons:copy"
                                color={phoneCopy ? 'text.secondary' : 'text.textG'}
                                sx={{ height: 15, width: 15, cursor: 'pointer', ml: 1 }}
                              />
                            </CopyToClipboard>
                          )}
                        </div>

                        <Typography
                          color={'text.secondary'}
                          sx={{
                            // fontWeight: "bold",
                            fontSize: "15px",
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            textTransform: 'capitalize',
                            cursor: "pointer",
                            textDecoration: "underline",
                          }} onClick={() => openSummary(item?.benchAppId?.summary)}>
                          {/* Summary - <span style={{ color: 'black', fontWeight: "normal" }}>{item?.summary}</span> */}
                          {/* {item?.benchAppId?.summary?item?.benchAppId?.summary:'-'} */}
                          summary
                        </Typography>

                      </Grid>

                      <Grid item xs={4}>

                        <div style={{ display: 'flex' }}>
                          <Typography
                            // color={'text.secondary'}
                            sx={{
                              fontWeight: "bold",
                              fontSize: "15px",
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              textTransform: 'capitalize',
                              // color: "#5e5a5a"
                            }}>
                            {/* Location - <span style={{ color: 'black', fontWeight: "normal" }}>{item?.city}, {item?.state}</span> */}
                            {item?.benchAppId?.cityOrZipcode ? item?.benchAppId?.cityOrZipcode : '-'}, {item?.benchAppId?.stateCode}
                          </Typography>
                          {(item?.relocation === "yes") && (
                            <Iconify icon="mdi:aeroplane" width="1rem" color={'text.secondary'} sx={{ ml: 0.3 }} />
                          )}   </div>


                        <Typography
                          // color={'text.secondary'} 
                          color="#5e5a5a"

                          sx={{
                            // fontWeight: "bold",
                            fontSize: "15px",
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            textTransform: 'capitalize',
                          }}>
                          Exp - <span style={{ color: "#5e5a5a", fontWeight: "normal" }}>
                            {item?.benchAppId?.experienceInYear ? `${item?.benchAppId?.experienceInYear} Yrs` : null}

                          </span>
                        </Typography>
                        {/* <Typography color={'text.secondary'}
                          sx={{
                            // fontWeight: "bold",
                            fontSize: "15px",
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            textTransform: 'capitalize',
                          }}>
                          Visa - <span style={{ color: "#5e5a5a", fontWeight: "normal" }}>{item?.benchAppId?.visa}</span>
                        </Typography> */}

                        <Typography
                          color={'text.secondary'}
                          sx={{
                            fontSize: '15px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            textTransform: 'capitalize',
                            // fontWeight: "bold"
                          }}
                        >
                          Salary/Rate - <span style={{ color: "#5e5a5a", fontWeight: 'normal' }}>
                            {item?.benchAppId?.expectedCompensation && (
                              <>
                                ${item?.benchAppId?.expectedCompensation}
                                {item?.benchAppId?.chargeType === "hourly" ? "/hour" :
                                  (item?.benchAppId?.chargeType === "Annually" ? 'k' : '')
                                }
                              </>
                            )}
                          </span>
                        </Typography>

                      </Grid>

                    </Grid>
                    <Stack
                      direction="row"
                      spacing={4}
                      justifyContent="center"
                      alignItems="center"
                      sx={{ width: '100%', mt: "9px", mb: "10px" }}
                    >
                      <Button color="custom" variant="contained" sx={{ width: "25%", p: 0.3 }}

                        // onClick={() => addToBench1(item?.benchAppId)}
                        onClick={() => moveToWorksheet(item?.benchAppId)}
                      >
                        Add to Worksheet
                      </Button>

                    </Stack>

                  </Box>
                </Grid>
              ))}
            </Grid>
            <Typography
              style={{
                textAlign: 'center',
                color: 'red',
                mt: 5,
                mb: 2
              }}
            >
              {/* No data found */}
              {loading1}
            </Typography>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: "10px" }}>

              {showAll2 ? <IconButton sx={{}}
                onClick={handleToggle2}
              >
                <Iconify
                  icon="bxs:up-arrow"
                // color="white"
                />
              </IconButton> : <IconButton sx={{}}
                onClick={handleToggle2}
              >
                <Iconify
                  icon="bxs:down-arrow"
                // color="white"
                />
              </IconButton>}

            </div>

          </>
        ) : (value === "vendor" && !vendorSearch) && (

          foxSearch?.length > 0 ? (

            // <Box
            //   sx={{
            //     // border: '3px solid #1E74B3',
            //     borderLeft: '3px solid #1E74B3',
            //     borderRight: '3px solid #1E74B3',
            //     borderBottom: '3px solid #1E74B3',
            //     borderTop: '3px solid #1E74B3',
            //     // borderRadius: '9px',
            //     borderBottomLeftRadius: '9px',
            //     borderBottomRightRadius: '9px',
            //     padding: '1rem',
            //     mt: -0.6, 
            //     // m:2,
            //     backgroundColor: "white",
            //     width: "100%" 
            //   }}
            // >
            <>

              <Stack sx={{ flexDirection: 'row' }}>

                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                  <Grid item xs={6} >
                    {foxSearch?.map((item, index) => (
                      <Grid container item xs={12} spacing={2} key={index} sx={{ mb: 1.7 }}>

                        <Grid item xs={12}>
                          <Box
                            sx={{
                              // border: '3px solid #1E74B3',
                              border: "2px solid rgb(164 176 191)",
                              borderRadius: '9px',
                              padding: '1rem',
                              // mt: "0.5rem",
                              // ml: -0.3,
                              // backgroundColor: !checkedStates[index] ? 'white' : tablebg,
                              backgroundColor: !checkedStates[item?._id]
                                ? (index % 2 === 0 ? 'text.background' : tablebg)
                                : tablebg,
                              width: '105%',
                              cursor: "pointer"
                            }}
                            onClick={() => setResumeUrl(item?.benchAppId?.resumeUrl)}
                          >
                            <Grid container spacing={0.1} alignItems="center" sx={{ justifyContent: 'space-between' }}>
                              <Grid
                                item
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",

                                  ml: -0.9,
                                  mt: -1,
                                  mr: -3,
                                }}
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={checkedStates[item?._id] || false}
                                      // onChange={() => handleCheckedSearch(item?._id)}
                                      onChange={() => handleCheckedSearch(item?._id, item?.benchAppId?.email, item?.benchAppId?.fullName)}
                                    />
                                  }
                                  label=""
                                /> 
                                <Iconify icon="fluent:prohibited-32-regular" width="1.4rem" color="red" sx={{ ml: -0.1 }}
                                  onClick={() => confirmOpenDelete(item?._id)} />
                              </Grid>

                              <Grid item xs={3.7}>
                                <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                  <Typography
                                    color={'text.secondary'}
                                    sx={{
                                      fontSize: '15px',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      fontWeight: 'bold',
                                      // flex: 1,
                                      maxWidth: 150,
                                      textTransform: 'capitalize',
                                      // color: "#5e5a5a"
                                    }}
                                  >
                                    {item?.benchAppId?.fullName ? item?.benchAppId?.fullName : '-'}
                                  </Typography>

                                  {item?.benchAppId?.fullName && (
                                    <Iconify
                                      icon="devicon:linkedin"
                                      color={'text.textG'}
                                      sx={{
                                        height: 15,
                                        width: 15,
                                        cursor: 'pointer',
                                        ml: 1,
                                      }}
                                      onClick={() => window?.open(item?.benchAppId?.linkedinUrl, '_blank')}
                                    />
                                  )}
                                </div>

                                <Typography
                                  color="#5e5a5a"
                                  sx={{
                                    fontSize: '15px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: 'flex',
                                    alignItems: 'center',

                                  }}
                                >
                                  Up -{" "}
                                  <span
                                    style={{
                                      color: '#5e5a5a',
                                      fontWeight: 'normal',
                                      marginLeft: '5px',
                                      marginRight: '5px',
                                    }}
                                  >
                                    {`${new Date(item?.benchAppId?.updatedAt).toLocaleString('en-US', optionsDate)}`}
                                  </span>
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                  <Typography
                                    sx={{
                                      fontSize: '15px',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      // flex: 1,
                                      maxWidth: 150,
                                      textTransform: 'capitalize',
                                      color: "#5e5a5a"
                                    }}
                                  >
                                    {item?.benchAppId?.email ? item?.benchAppId?.email : '-'}
                                  </Typography>
                                  {item?.benchAppId?.email && (
                                    <CopyToClipboard text={item?.benchAppId?.email} onCopy={() => setEmailCopy(true)}>
                                      <Iconify
                                        icon="radix-icons:copy"
                                        color={emailCopy ? 'text.secondary' : 'text.textG'}
                                        sx={{ height: 15, width: 15, cursor: 'pointer', ml: 1 }}
                                      />
                                    </CopyToClipboard>
                                  )}
                                </div>

                                <Typography
                                  color={'text.secondary'}

                                  sx={{
                                    fontSize: "15px",
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    textTransform: 'capitalize',
                                    display: 'inline',
                                  }}
                                >
                                  {/* <span style={{ color: "#5e5a5a", fontWeight: "normal" }}>
                                    {item?.benchAppId?.skill?.slice(0, 1).join(', ')}{item?.benchAppId?.skill.length > 1 ? '...' : '-'}
                                  </span> */}
                                  {/* {item?.benchAppId?.skill?.length > 1 && ( */}
                                  <span
                                    tabIndex={0}
                                    role="button"
                                    style={{ color: '#1E74B3', textDecoration: 'underline', cursor: 'pointer' }}
                                    onClick={() => handleOpens(item?.benchAppId?.skill)}
                                    onKeyDown={(e) => e.key === 'Enter' && handleOpens(item?.benchAppId?.skill)}
                                  >
                                    Skills
                                  </span>
                                  {/* )} */}
                                </Typography>
                              </Grid>

                              <Grid item xs={3.7}>
                                <Typography
                                  sx={{
                                    fontWeight: "bold",
                                    fontSize: '15px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    textTransform: 'capitalize',
                                  }}
                                >
                                  {item?.jobTitle ? item?.jobTitle : '-'}
                                </Typography>
                                <Typography
                                  // color={'text.secondary'}
                                  color='#5e5a5a'
                                  sx={{
                                    fontSize: '15px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    textTransform: 'capitalize',
                                  }}
                                >
                                  Visa - <span style={{ color: '#5e5a5a', fontWeight: 'normal' }}>{item?.benchAppId?.visaType}</span>
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <Typography
                                    sx={{
                                      fontSize: '15px',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      color: "#5e5a5a"
                                    }}
                                  >
                                    {item?.benchAppId?.phone ? item?.benchAppId?.phone : '-'}
                                  </Typography>
                                  {item?.benchAppId?.phone && (
                                    <CopyToClipboard text={item?.benchAppId?.phone} onCopy={() => setPhoneCopy(true)}>
                                      <Iconify
                                        icon="radix-icons:copy"
                                        color={phoneCopy ? 'text.secondary' : 'text.textG'}
                                        sx={{ height: 15, width: 15, cursor: 'pointer', ml: 1 }}
                                      />
                                    </CopyToClipboard>
                                  )}
                                </div>
                                {/* <Typography
                                  color={'text.secondary'}
                                  sx={{
                                    fontSize: '15px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    textTransform: 'capitalize',
                                  }}
                                >
                                  Tex Term - <span style={{ color: "#5e5a5a", fontWeight: 'normal' }}>{item?.benchAppId?.taxTerm}</span>
                                </Typography> */}
                                <Typography
                                  color={'text.secondary'}
                                  sx={{
                                    // fontWeight: "bold",
                                    fontSize: "15px",
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    textTransform: 'capitalize',
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                  }} onClick={() => openSummary(item?.benchAppId?.summary)}>

                                  summary
                                </Typography>
                              </Grid>

                              <Grid item xs={3.7} sx={{ mr: -1 }}>
                                <Typography
                                  sx={{
                                    fontSize: '15px',
                                    fontWeight: "bold",
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    textTransform: 'capitalize',
                                    // color:"#5e5a5a"
                                  }}
                                >
                                  {item?.benchAppId?.currentCompany ? item?.benchAppId?.currentCompany : '-'}
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <Typography
                                    sx={{
                                      fontSize: '15px',
                                      // fontWeight:"bold",
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      textTransform: 'capitalize',
                                      color: "#5e5a5a"
                                    }}
                                  >
                                    {item?.benchAppId?.city}, {item?.benchAppId?.stateCode}
                                  </Typography>
                                  {(item?.relocation === "yes") && (
                                    <Iconify icon="mdi:aeroplane" width="1rem" color={'text.secondary'} sx={{ ml: 0.3 }} />
                                  )}
                                </div>
                                <Typography
                                  // color={'text.secondary'}
                                  color='#5e5a5a'
                                  sx={{
                                    fontSize: '15px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    textTransform: 'capitalize',
                                  }}
                                >
                                  Exp - <span style={{ color: "#5e5a5a", fontWeight: 'normal' }}>
                                    {item?.benchAppId?.experienceInYear ? `${item?.benchAppId?.experienceInYear} Yrs` : null}
                                  </span>
                                </Typography>
                                <Typography
                                  color={'text.secondary'}
                                  sx={{
                                    fontSize: '15px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    textTransform: 'capitalize',
                                  }}
                                >
                                  Salary/Rate - <span style={{ color: "#5e5a5a", fontWeight: 'normal' }}>
                                    {item?.benchAppId?.expectedCompensation && (
                                      <>
                                        ${item?.benchAppId?.expectedCompensation}
                                        {item?.benchAppId?.chargeType === "hourly" ? "/hour" :
                                          (item?.benchAppId?.chargeType === "Annually" ? 'k' : '')
                                        }
                                      </>
                                    )}
                                  </span>
                                </Typography>
                              </Grid>

                            </Grid>
                          </Box>
                        </Grid>

                      </Grid>
                    ))}
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      sx={{
                        // border: '3px solid #1E74B3',
                        border: "2px solid rgb(164 176 191)",
                        borderRadius: '9px',
                        padding: '1rem',
                        // mt: 1,
                        ml: 2.5,
                        backgroundColor: "white",
                        width: '97%',
                        // width: '43%',
                        // maxWidth: '43%',
                        // minWidth: '0',
                        maxHeight: "900px"
                      }}
                    >
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', mt: -2.5 }}>
                        <Typography variant="h6" sx={{ textAlign: 'center', color: 'text.secondary', fontWeight: 'bold', flex: 1 }}>
                          {/* {/ Resume /} */}
                        </Typography>
                        <a href={(resumeUrl?.benchAppId?.resumeUrl || resumeUrl)} download>
                          <Iconify icon="mdi:download" width="1.3rem" color='text.secondary' sx={{ mt: 1 }} />
                        </a>
                      </Box>
                      <Scrollbar sx={{ maxHeight: 792, Scrollbar: 'thin' }}>
                        <iframe title="resume" src={suru + (resumeUrl?.benchAppId?.resumeUrl || resumeUrl) + lll} width="100%" height="790px" />
                      </Scrollbar>
                    </Box>
                  </Grid>
                </Grid>

              </Stack>

              <Stack
                direction="row"
                spacing={4}
                justifyContent="center"
                alignItems="center"
                sx={{ width: '100%', mt: 4 }}
              >
                <Button color="custom" variant="contained" sx={{ width: "18%" }}
                  disabled={Object?.values(checkedStates)?.every(value => !value) || value === "vendor"}
                  // onClick={() => addToBench()}
                  onClick={() => moveTo()}
                > 
                  Add to Worksheet
                </Button>
                <Button color="custom" variant="contained" sx={{ width: "18%" }}
                  onClick={() => handleOpenModal(foxSearch[0]?.email)}>
                    Email
                </Button>
              </Stack>

              {tableCount > 6 ? (
                <Stack
                  spacing={2}
                  sx={{
                    width: '100%',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    mt: 2
                  }}
                >

                  <Button
                    variant="outlined"
                    sx={{
                      minWidth: 16, height: 32, borderRadius: '5px',
                      mt: 2,
                      ml: 0.5, cursor: 'pointer'
                    }}
                    onClick={() => setPageNumber(prev => Math.max(prev - 1, 1))}
                  >
                    {"<"}
                  </Button>

                  <Pagination
                    variant="outlined"
                    shape="rounded"
                    color="secondary"
                    hideNextButton
                    hidePrevButton
                    count={pages}
                    page={pageNumber}
                    onChange={handlePage}
                    sx={{ cursor: 'pointer', mb: (pageNumber !== 1) ? -4 : -2 }}
                  />

                  <Button
                    variant="outlined"
                    sx={{
                      minWidth: 16, height: 32, borderRadius: '5px', mr: 1,
                      mt: -2,
                      cursor: 'pointer'
                    }}
                    onClick={() => setPageNumber(prev => Math.min(prev + 1, pages))}
                  >
                    {">"}
                  </Button>

                </Stack>

              ) : null}

            </>
            // </Box>
          ) : (
            <Typography
              style={{
                textAlign: 'center',
                color: 'red',
                mt: 5,
                mb: 2
              }}
            >
              {/* No data found */}
              {loading}
            </Typography>
          )
        )}
        {/* </Box> */}
      </Box>

      <Modal open={opens} onClose={handleCloses} style={{ borderRadius: 10 }}>
        <Box sx={styleSkillset11}>
          <Typography variant="h5" color={'#3C6BA5'} sx={{ ml: "46%" }}>
            Skills
          </Typography>
          <Scrollbar sx={{ maxHeight: 600, Scrollbar: 'thin' }}>
            <Divider sx={{ mt: 0.5, borderWidth: 1.7, borderColor: '#3C6BA5' }} />
            <Stack
              sx={{
                flexDirection: 'row',
                justifyContent: 'center',
                gap: 0.5,
                flexWrap: 'wrap'
              }}
            >

              {skillsArrayLst?.filter(item => item !== '' && item != null)?.map((item, index) => (

                item && (
                  <Box
                    key={index}
                    sx={{
                      position: 'relative',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mt: 2,
                    }}
                  >
                    <Typography
                      variant="h6"
                      color="text.textG"
                      textAlign="center"
                      textTransform="capitalize"
                      sx={{ paddingRight: '2px', position: 'relative', paddingTop: '-3px' }}
                    >
                      {item} {index < skillsArrayLst?.length - 1 && '|'}

                    </Typography>
                  </Box>
                )
              ))}

            </Stack>
          </Scrollbar>
        </Box>
      </Modal>

      <Modal open={summaryModal} onClose={closeSummary} style={{ borderRadius: 10 }}>
        <Box sx={styleClients1}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ width: '100%' }}
          >
            <Typography
              variant="h5"
              color={'#3C6BA5'}
              textAlign={'center'}
              sx={{ flexGrow: 1, textAlign: 'center' }}
            >
              Summary
            </Typography>

          </Stack>

          <Divider sx={{ mt: 1, mb: 1, borderWidth: 1.7, borderColor: '#3C6BA5' }} />

          <Typography sx={{ width: '100%', fontSize: '0.976rem', fontWeight: '100' }}>
            {summary}
          </Typography>

        </Box>
      </Modal>

      <Modal open={openConfirmDelete} onClose={confirmCloseDelete} style={{ borderRadius: 10 }}>
        <Box sx={[styless, { width: '20%' }]}>
          <Stack sx={{ justifyContent: "center", alignContent: 'center', width: '100%' }}>
            <Stack sx={{ width: "100%" }}>
              <TextField
                label="Reason"
                variant="outlined"
                // size="small"
                fullWidth
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
            </Stack>
            <Stack sx={{
              flexDirection: 'row', justifyContent: 'space-between',
              width: '25%', mt: 3, alignSelf: 'center', gap: 3
            }}>
              <Button color="custom" sx={{}} variant="contained"
                onClick={() => spamData()}
              >
                Submit
              </Button>
              <Button color="custom" sx={{}} variant="contained" onClick={confirmCloseDelete}>
                Close
              </Button>
            </Stack>
          </Stack>

        </Box>
      </Modal>

<Modal open={modalOpen} onClose={handleCloseModal} style={{ borderRadius: 10 }}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '95%', sm: '70%' },
          // width: { xs: '85%', sm: '60%' },
          bgcolor: 'background.paper',
          border: '3px solid #3C6BA5',
          boxShadow: 24,
          p: 3,
          borderRadius: 3,
        }}
        >
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Send Email
          </Typography>
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            {/* <Divider sx={{ mb: 2 }} /> */}
            <Grid container spacing={1} mt={1}>
              <Grid item xs={5.9}>
                <TextField
                  fullWidth
                  required
                  label="To"
                  variant="outlined"
                  size="small"
                  // value={to}
                  value={recipientEmail}
                  // onChange={(e) => setTo(e.target.value)}
                  onChange={(e) => setRecipientEmail(e.target.value)}
                />
              </Grid>
              <Grid item xs={5.9}>
                <Autocomplete
                  size='small'
                  multiple
                  id="tags-outlined"
                  onChange={(event, newValue) => {
                    setCcEmail([...newValue]);
                  }}
                  options={[{ title: '' }]}
                  getOptionLabel={(option) => option.title}
                  value={ccEmail.map((item) => item)}
                  filterSelectedOptions
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    const { inputValue } = params;
                    // Suggest the creation of a new value
                    const isExisting = options.some((option) => inputValue === option.title);
                    if (inputValue !== '' && !isExisting) {
                      filtered.push({
                        inputValue,
                        title: `${inputValue}`,
                      });
                    }
                    return filtered;
                  }}
                  renderInput={(params) => <TextField {...params} label="Cc" placeholder="Cc"

                    size="small"
                  />}
                />
              </Grid>
            </Grid>
            <Grid container spacing={1} mt={1}>
              <Grid item xs={5.9}>
                <Autocomplete
                  multiple
                  size="small"
                  id="tags-outlined"
                  value={bccEmail}
                  onChange={(event, newValue) => {
                    setBccEmail(newValue);
                  }}
                  options={[]}
                  getOptionLabel={(option) => option.email || option.title || ''}
                  isOptionEqualToValue={(option, value) => option.email === value.email}
                  filterSelectedOptions
                  filterOptions={(options, params) => {
                    const { inputValue } = params;

                    const isExisting = bccEmail.some((item) => item.email === inputValue);
                    if (inputValue !== '' && !isExisting) {
                      return [
                        ...options,
                        {
                          name: '',
                          email: inputValue,
                        },
                      ];
                    }

                    return options;
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Others"
                      placeholder="Others"
                      multiline
                      rows={3}
                      size="small"
                      InputProps={{
                        ...params.InputProps,
                        sx: {
                          alignItems: 'flex-start',
                          '& textarea': {
                            textAlign: 'left',
                            paddingTop: '1px !important',
                          },
                        },
                      }}
                    />
                  )}
                />

              </Grid>

<Grid item xs={5} sx={{}}>
                <FormControl variant="outlined" fullWidth size="small" >
                  <InputLabel >Select Template</InputLabel>
                  <Select
                    label="Select Template"
                   
                    onChange={(e) => handleTemplateSelect(e.target.value)}
                  >
                    {tempList?.map((item) => (
                      <MenuItem key={item?.id} value={item}>
                        {item?.templateName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl> 
              </Grid>

<Typography
                onClick={() => navigate('/Email', { state: { undid: "undid", bodyDis: "bodyDis" } })}
                sx={{
                  color: '#23A6F0',
                  fontWeight: 'bold',
                  fontSize: '17px',
                  marginLeft: '30px',
                  marginTop: '12px',
                  cursor: 'pointer',
                }}
              >
                Edit
              </Typography>

            </Grid>

<Grid container alignItems="center" style={{ flexDirection: 'row' }}>
  <Grid item xs={12} style={{ display: 'flex', alignItems: 'center' }}>
    <Typography sx={{ ml: 1, color: '#1E74B3', whiteSpace: 'nowrap' }}>
      Attachment:
    </Typography>
    <input
      type="file"
      onChange={FileChange}
      style={{
        marginLeft: '9px',
        flex: 1,        
        minWidth: 0,   
      }}
    />
  </Grid>
</Grid>

            <Grid container spacing={1}>
              <Grid item xs={11.8}>
                <TextField
                  label='Sub'
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="small"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  InputProps={{ style: { borderRadius: '10px', paddingLeft: '5px' } }}
                // InputLabelProps={{ style: { marginLeft: '14px' } }}
                />
              </Grid>
              <Grid item xs={11.8}>
                <Stack sx={{ flexDirection: 'row', gap: 1, alignItems: 'center' }}>

                  <Typography>Hello {'{Name},'}</Typography>
                </Stack>
              </Grid>
              <Grid item xs={11.8}>
                <CKEditor
                  data={emailBody}
                  config={{
    // licenseKey: process.env.REACT_APP_TLK,
    // toolbar: [
    //   'heading', '|',
    //   'bold', 'italic', 'link', '|',
    //   'insertImage', 'undo', 'redo'
    // ],
    extraPlugins: [ MyCustomUploadAdapterPlugin ]
  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    // console.log("body", data)
                    setEmailBody(data);
                  }}
                  editor={ClassicEditor}
                />
              </Grid>
            </Grid>
            <Stack sx={{ mt: 1 }}>

              <div dangerouslySetInnerHTML={{ __html: localStorage.getItem('sign') }} />
            </Stack>

            <Stack flexDirection={'row'} gap={1} mt={1} sx={{ justifyContent: 'center' }}>
              <Button
                color="custom"
                variant="contained"
                // onClick={SendEmail}
                disabled={recipientEmail === '' || subject === '' || loadingSend}
                onClick={() => sendBulkEmail()}>
                {/* Send */}
                  {loadingSend ? "Sending" : 'Send'}
              </Button>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal>

    </>
  );
}

export default ResumeDatabase;
